export const data = {
  data: [
    {
      name: '渤海北部一天津航路',
      split: [10, 4],
      point: 1,
      distance: 6,
      lat: 39.963611,
      lng: 121.379167,
      isDiff: true,
    },
    {
      name: '渤海北部一天津航路',
      split: [10, 4],
      point: 2,
      distance: 3,
      lat: 39.550556,
      lng: 120.98,
      isDiff: true,
    },
    {
      name: '渤海北部一天津航路',
      split: [10, 4],
      point: 3,
      distance: 3,
      lat: 39.393056,
      lng: 120.388056,
      isDiff: true,
    },
    {
      name: '渤海北部一天津航路',
      split: [10, 4],
      point: 4,
      distance: 3,
      lat: 38.748333,
      lng: 119.294444,
      isDiff: true,
    },
    {
      name: '北关岛至浮鹰岛',
      point: 1,
      lat: 27.107167,
      lng: 120.558889,
      distance: 0.4,
      split: [8, 16],
    },
    {
      name: '北关岛至浮鹰岛',
      point: 2,
      lat: 27.073278,
      lng: 120.522028,
      distance: 0.4,
      split: [8, 16],
    },
    {
      name: '北关岛至浮鹰岛',
      point: 3,
      lat: 26.993444,
      lng: 120.452889,
      distance: 0.4,
      split: [8, 16],
    },
    {
      name: '北关岛至浮鹰岛',
      point: 4,
      lat: 26.912083,
      lng: 120.399583,
      distance: 0.4,
      split: [8, 16],
    },
    {
      name: '北关岛至浮鹰岛',
      point: 5,
      lat: 26.685556,
      lng: 120.189722,
      distance: 0.4,
      split: [8, 16],
    },
    {
      name: '北关岛至浮鹰岛',
      point: 6,
      lat: 26.612917,
      lng: 120.126556,
      distance: 0.4,
      split: [8, 16],
    },

    {
      name: '浮鹰岛至洋屿（南向）',
      point: 1,
      lat: 26.612917,
      lng: 120.126556,
      distance: 0.4,
      split: [4, 10],
    },
    {
      name: '浮鹰岛至洋屿（南向）',
      point: 2,
      lat: 26.59,
      lng: 120.097306,
      distance: 0.4,
      split: [4, 10],
    },
    {
      name: '浮鹰岛至洋屿（南向）',
      point: 3,
      lat: 26.499944,
      lng: 120.079778,
      distance: 0.4,
      split: [4, 10],
    },
    {
      name: '浮鹰岛至洋屿（南向）',
      point: 4,
      lat: 26.377556,
      lng: 120.00525,
      distance: 0.4,
      split: [4, 10],
    },

    {
      name: '洋屿至浮鹰岛（北向）',
      point: 1,
      lat: 26.371306,
      lng: 120.013278,
      distance: 0.4,
      split: [4, 10],
    },
    {
      name: '洋屿至浮鹰岛（北向）',
      point: 2,
      lat: 26.499583,
      lng: 120.086306,
      distance: 0.4,
      split: [4, 10],
    },
    {
      name: '洋屿至浮鹰岛（北向）',
      point: 3,
      lat: 26.559944,
      lng: 120.100861,
      distance: 0.4,
      split: [4, 10],
    },
    {
      name: '洋屿至浮鹰岛（北向）',
      point: 4,
      lat: 26.612917,
      lng: 120.126556,
      distance: 0.4,
      split: [4, 10],
    },

    {
      name: '西台山至魁山岛',
      point: 1,
      lat: 27.086667,
      lng: 120.603333,
      distance: 0.4,
      split: [5, 13],
    },
    {
      name: '西台山至魁山岛',
      point: 2,
      lat: 26.916417,
      lng: 120.476194,
      distance: 0.4,
      split: [5, 13],
    },
    {
      name: '西台山至魁山岛',
      point: 3,
      lat: 26.719306,
      lng: 120.312194,
      distance: 0.4,
      split: [5, 13],
    },
    {
      name: '西台山至魁山岛',
      point: 4,
      lat: 26.544722,
      lng: 120.196667,
      distance: 0.4,
      split: [5, 13],
    },
    {
      name: '西台山至魁山岛',
      point: 5,
      lat: 26.50625,
      lng: 120.121556,
      distance: 0.4,
      split: [5, 13],
    },
    {
      name: '魁山岛至闽江口（南向）',
      point: 1,
      lat: 26.50625,
      lng: 120.121556,
      distance: 0.4,
      split: [5, 10],
    },
    {
      name: '魁山岛至闽江口（南向）',
      point: 2,
      lat: 26.227778,
      lng: 119.869444,
      distance: 0.4,
      split: [5, 10],
    },
    {
      name: '魁山岛至闽江口（南向）',
      point: 3,
      lat: 26.178167,
      lng: 119.85,
      distance: 0.4,
      split: [5, 10],
    },
    {
      name: '魁山岛至闽江口（南向）',
      point: 4,
      lat: 26.036889,
      lng: 119.85,
      distance: 0.4,
      split: [5, 10],
    },

    {
      name: '闽江口至魁山岛（北向）',
      point: 1,
      lat: 26.036889,
      lng: 119.873611,
      distance: 0.4,
      split: [3, 10],
    },
    {
      name: '闽江口至魁山岛（北向）',
      point: 2,
      lat: 26.1485,
      lng: 119.873611,
      distance: 0.4,
      split: [3, 10],
    },
    {
      name: '闽江口至魁山岛（北向）',
      point: 3,
      lat: 26.299222,
      lng: 119.955917,
      distance: 0.4,
      split: [3, 10],
    },
    {
      name: '闽江口至魁山岛（北向）',
      point: 4,
      lat: 26.50625,
      lng: 120.121556,
      distance: 0.4,
      split: [3, 10],
    },

    {
      name: '闽江口至东洛岛东（南向）',
      point: 1,
      lat: 26.036889,
      lng: 119.85,
      distance: 0.4,
      split: [1, 4],
    },
    {
      name: '闽江口至东洛岛东（南向）',
      point: 2,
      lat: 25.766222,
      lng: 119.724056,
      distance: 0.4,
      split: [1, 4],
    },

    {
      name: '东洛岛东至闽江口（北向）',
      point: 1,
      lat: 25.766222,
      lng: 119.724056,
      distance: 0.4,
      split: [1, 4],
    },
    {
      name: '东洛岛东至闽江口（北向）',
      point: 2,
      lat: 26.036889,
      lng: 119.873611,
      distance: 0.4,
      split: [1, 4],
    },

    {
      name: '东洛岛东至鼓屿门航道',
      point: 1,
      lat: 25.766222,
      lng: 119.724056,
      distance: 0.4,
      split: [4, 10],
    },
    {
      name: '东洛岛东至鼓屿门航道',
      point: 2,
      lat: 25.735667,
      lng: 119.70925,
      distance: 0.4,
      split: [4, 10],
    },
    {
      name: '东洛岛东至鼓屿门航道',
      point: 3,
      lat: 25.719111,
      lng: 119.678833,
      distance: 0.4,
      split: [4, 10],
    },
    {
      name: '东洛岛东至鼓屿门航道',
      point: 4,
      lat: 25.694028,
      lng: 119.650972,
      distance: 0.4,
      split: [4, 10],
    },

    {
      name: '鼓屿门航道至平潭海峡大桥北',
      point: 1,
      lat: 25.694028,
      lng: 119.650972,
      distance: 0.4,
      split: [1, 25],
    },
    {
      name: '鼓屿门航道至平潭海峡大桥北',
      point: 2,
      lat: 25.680444,
      lng: 119.629611,
      distance: 0.4,
      split: [1, 25],
    },
    {
      name: '鼓屿门航道至平潭海峡大桥北',
      point: 3,
      lat: 25.665694,
      lng: 119.625833,
      distance: 0.4,
      split: [1, 25],
    },
    {
      name: '鼓屿门航道至平潭海峡大桥北',
      point: 4,
      lat: 25.650806,
      lng: 119.625667,
      distance: 0.4,
      split: [1, 25],
    },
    {
      name: '鼓屿门航道至平潭海峡大桥北',
      point: 5,
      lat: 25.613333,
      lng: 119.628222,
      distance: 0.4,
      split: [1, 25],
    },
    {
      name: '鼓屿门航道至平潭海峡大桥北',
      point: 6,
      lat: 25.585778,
      lng: 119.632361,
      distance: 0.4,
      split: [1, 25],
    },
    {
      name: '鼓屿门航道至平潭海峡大桥北',
      point: 7,
      lat: 25.541361,
      lng: 119.650806,
      distance: 0.4,
      split: [1, 25],
    },
    {
      name: '鼓屿门航道至平潭海峡大桥北',
      point: 8,
      lat: 25.525222,
      lng: 119.652417,
      distance: 0.4,
      split: [1, 25],
    },
    {
      name: '鼓屿门航道至平潭海峡大桥北',
      point: 9,
      lat: 25.49675,
      lng: 119.654222,
      distance: 0.4,
      split: [1, 25],
    },
    {
      name: '大小练航道进出海坛海峡',
      point: 1,
      lat: 25.613333,
      lng: 119.628222,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '大小练航道进出海坛海峡',
      point: 2,
      lat: 25.644806,
      lng: 119.641528,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '大小练航道进出海坛海峡',
      point: 3,
      lat: 25.665611,
      lng: 119.675,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '大小练航道进出海坛海峡',
      point: 4,
      lat: 25.717861,
      lng: 119.714194,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '大小练航道进出海坛海峡',
      point: 5,
      lat: 25.778583,
      lng: 119.797306,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '平潭海峡大桥桥区（南向）',
      point: 1,
      lat: 25.49675,
      lng: 119.654222,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '平潭海峡大桥桥区（南向）',
      point: 2,
      lat: 25.486889,
      lng: 119.657889,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '平潭海峡大桥桥区（南向）',
      point: 3,
      lat: 25.481361,
      lng: 119.659583,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '平潭海峡大桥桥区（南向）',
      point: 4,
      lat: 25.468083,
      lng: 119.663028,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '平潭海峡大桥桥区（南向）',
      point: 5,
      lat: 25.459278,
      lng: 119.667806,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '平潭海峡大桥桥区（北向）',
      point: 1,
      lat: 25.459278,
      lng: 119.667806,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '平潭海峡大桥桥区（北向）',
      point: 2,
      lat: 25.467333,
      lng: 119.665167,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '平潭海峡大桥桥区（北向）',
      point: 3,
      lat: 25.481917,
      lng: 119.661528,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '平潭海峡大桥桥区（北向）',
      point: 4,
      lat: 25.487139,
      lng: 119.658833,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '平潭海峡大桥桥区（北向）',
      point: 5,
      lat: 25.49675,
      lng: 119.654222,
      distance: 0.4,
      split: [13, 5],
    },
    {
      name: '平潭海峡大桥至南日水道',
      point: 1,
      lat: 25.459278,
      lng: 119.667806,
      distance: 0.4,
      split: [15, 34],
    },
    {
      name: '平潭海峡大桥至南日水道',
      point: 2,
      lat: 25.45425,
      lng: 119.671222,
      distance: 0.4,
      split: [15, 34],
    },
    {
      name: '平潭海峡大桥至南日水道',
      point: 3,
      lat: 25.429083,
      lng: 119.680694,
      distance: 0.4,
      split: [15, 34],
    },
    {
      name: '平潭海峡大桥至南日水道',
      point: 4,
      lat: 25.407639,
      lng: 119.689889,
      distance: 0.4,
      split: [15, 34],
    },
    {
      name: '平潭海峡大桥至南日水道',
      point: 5,
      lat: 25.394306,
      lng: 119.688306,
      distance: 0.4,
      split: [15, 34],
    },
    {
      name: '平潭海峡大桥至南日水道',
      point: 6,
      lat: 25.314361,
      lng: 119.637056,
      distance: 0.4,
      split: [15, 34],
    },
    {
      name: '平潭海峡大桥至南日水道',
      point: 7,
      lat: 25.293306,
      lng: 119.602611,
      distance: 0.4,
      split: [15, 34],
    },
    {
      name: '平潭海峡大桥至南日水道',
      point: 8,
      lat: 25.308222,
      lng: 119.553639,
      distance: 0.4,
      split: [15, 34],
    },
    {
      name: '平潭海峡大桥至南日水道',
      point: 9,
      lat: 25.289028,
      lng: 119.510417,
      distance: 0.4,
      split: [15, 34],
    },
    {
      name: '平潭海峡大桥至南日水道',
      point: 10,
      lat: 25.274917,
      lng: 119.480833,
      distance: 0.4,
      split: [15, 34],
    },
    {
      name: '平潭海峡大桥至南日水道',
      point: 11,
      lat: 25.263667,
      lng: 119.44475,
      distance: 0.4,
      split: [15, 34],
    },
    {
      name: '平潭海峡大桥至南日水道',
      point: 12,
      lat: 25.234944,
      lng: 119.415167,
      distance: 0.4,
      split: [15, 34],
    },
    {
      name: '白屿经目屿至南日水道',
      point: 1,
      lat: 25.308222,
      lng: 119.553639,
      distance: 0.4,
      split: [5, 10],
    },
    {
      name: '白屿经目屿至南日水道',
      point: 2,
      lat: 25.321056,
      lng: 119.510417,
      distance: 0.4,
      split: [5, 10],
    },
    {
      name: '白屿经目屿至南日水道',
      point: 3,
      lat: 25.317611,
      lng: 119.460778,
      distance: 0.4,
      split: [5, 10],
    },
    {
      name: '白屿经目屿至南日水道',
      point: 4,
      lat: 25.234944,
      lng: 119.415167,
      distance: 0.4,
      split: [5, 10],
    },
    {
      name: '南日水道至祥芝角（南向）',
      point: 1,
      lat: 25.129889,
      lng: 119.276389,
      distance: 0.4,
      split: [9, 22],
    },
    {
      name: '南日水道至祥芝角（南向）',
      point: 2,
      lat: 25.08375,
      lng: 119.235556,
      distance: 0.4,
      split: [9, 22],
    },
    {
      name: '南日水道至祥芝角（南向）',
      point: 3,
      lat: 25.029333,
      lng: 119.197389,
      distance: 0.4,
      split: [9, 22],
    },
    {
      name: '南日水道至祥芝角（南向）',
      point: 4,
      lat: 24.955389,
      lng: 119.128861,
      distance: 0.4,
      split: [9, 22],
    },
    {
      name: '南日水道至祥芝角（南向）',
      point: 5,
      lat: 24.930861,
      lng: 119.102111,
      distance: 0.4,
      split: [9, 22],
    },
    {
      name: '南日水道至祥芝角（南向）',
      point: 6,
      lat: 24.883083,
      lng: 119.053722,
      distance: 0.4,
      split: [9, 22],
    },
    {
      name: '南日水道至祥芝角（南向）',
      point: 7,
      lat: 24.840278,
      lng: 119.009778,
      distance: 0.4,
      split: [9, 22],
    },
    {
      name: '南日水道至祥芝角（南向）',
      point: 8,
      lat: 24.705361,
      lng: 118.859639,
      distance: 0.4,
      split: [9, 22],
    },
    {
      name: '祥芝角至南日水道（北向）',
      point: 1,
      lat: 24.705361,
      lng: 118.859639,
      distance: 0.4,
      split: [19, 10],
    },
    {
      name: '祥芝角至南日水道（北向）',
      point: 2,
      lat: 24.835694,
      lng: 119.013778,
      distance: 0.4,
      split: [19, 10],
    },
    {
      name: '祥芝角至南日水道（北向）',
      point: 3,
      lat: 24.877583,
      lng: 119.059889,
      distance: 0.4,
      split: [19, 10],
    },
    {
      name: '祥芝角至南日水道（北向）',
      point: 4,
      lat: 24.925278,
      lng: 119.108444,
      distance: 0.4,
      split: [19, 10],
    },
    {
      name: '祥芝角至南日水道（北向）',
      point: 5,
      lat: 24.950889,
      lng: 119.135944,
      distance: 0.4,
      split: [19, 10],
    },
    {
      name: '祥芝角至南日水道（北向）',
      point: 6,
      lat: 25.073306,
      lng: 119.252417,
      distance: 0.4,
      split: [19, 10],
    },
    {
      name: '祥芝角至南日水道（北向）',
      point: 7,
      lat: 25.12175,
      lng: 119.287111,
      distance: 0.4,
      split: [19, 10],
    },
    {
      name: '祥芝角至东碇岛',
      point: 1,
      lat: 24.705361,
      lng: 118.859639,
      distance: 0.4,
      split: [1, 4],
    },
    {
      name: '祥芝角至东碇岛',
      point: 2,
      lat: 24.118056,
      lng: 118.260556,
      distance: 0.4,
      split: [1, 4],
    },
    {
      name: '闽江口至东庠角（南向）',
      point: 1,
      lat: 26.036889,
      lng: 119.85,
      distance: 0.4,
      split: [3, 7],
    },
    {
      name: '闽江口至东庠角（南向）',
      point: 2,
      lat: 25.973278,
      lng: 119.85,
      distance: 0.4,
      split: [3, 7],
    },
    {
      name: '闽江口至东庠角（南向）',
      point: 3,
      lat: 25.61025,
      lng: 119.961167,
      distance: 0.4,
      split: [3, 7],
    },
    {
      name: '东庠角至闽江口（北向）',
      point: 1,
      lat: 25.61025,
      lng: 119.961167,
      distance: 0.4,
      split: [1, 4],
    },
    {
      name: '东庠角至闽江口（北向）',
      point: 2,
      lat: 26.036889,
      lng: 119.873611,
      distance: 0.4,
      split: [1, 4],
    },
    {
      name: '东庠角至东山岛',
      point: 1,
      lat: 25.61025,
      lng: 119.961167,
      distance: 0.4,
      split: [10, 25],
    },
    {
      name: '东庠角至东山岛',
      point: 2,
      lat: 25.2375,
      lng: 119.775,
      distance: 0.4,
      split: [10, 25],
    },
    {
      name: '东庠角至东山岛',
      point: 3,
      lat: 25.058333,
      lng: 119.504167,
      distance: 0.4,
      split: [10, 25],
    },
    {
      name: '东庠角至东山岛',
      point: 4,
      lat: 25.009611,
      lng: 119.408333,
      distance: 0.4,
      split: [10, 25],
    },
    {
      name: '东庠角至东山岛',
      point: 5,
      lat: 24.118056,
      lng: 118.260556,
      distance: 0.4,
      split: [10, 25],
    },
    {
      name: '东庠角至东山岛',
      point: 6,
      lat: 23.757778,
      lng: 117.750833,
      distance: 0.4,
      split: [10, 25],
    },
    {
      name: '东庠角至东山岛',
      point: 7,
      lat: 23.638889,
      lng: 117.605556,
      distance: 0.4,
      split: [10, 25],
    },
    {
      name: '东庠角至东山岛',
      point: 8,
      lat: 23.550833,
      lng: 117.457222,
      distance: 0.4,
      split: [10, 25],
    },
    {
      name: '东庠角至东山岛',
      point: 9,
      lat: 23.5,
      lng: 117.358889,
      distance: 0.4,
      split: [10, 25],
    },
    {
      name: '中航路',
      point: 1,
      lat: 27.0,
      lng: 120.893056,
      distance: 0.4,
      split: [7, 19],
    },
    {
      name: '中航路',
      point: 2,
      lat: 26.406667,
      lng: 120.398611,
      distance: 0.4,
      split: [7, 19],
    },
    {
      name: '中航路',
      point: 3,
      lat: 25.416667,
      lng: 119.971667,
      distance: 0.4,
      split: [7, 19],
    },
    {
      name: '中航路',
      point: 4,
      lat: 25.195278,
      lng: 119.819722,
      distance: 0.4,
      split: [7, 19],
    },
    {
      name: '中航路',
      point: 5,
      lat: 24.934444,
      lng: 119.498611,
      distance: 0.4,
      split: [7, 19],
    },
    {
      name: '中航路',
      point: 6,
      lat: 24.062222,
      lng: 118.313889,
      distance: 0.4,
      split: [7, 19],
    },
    {
      name: '中航路',
      point: 7,
      lat: 23.5,
      lng: 117.518056,
      distance: 0.4,
      split: [7, 19],
    },
    {
      name: '南向航行外航路',
      point: 1,
      lat: 27.0,
      lng: 121.258333,
      distance: 0.4,
      split: [3, 10],
    },
    {
      name: '南向航行外航路',
      point: 2,
      lat: 26.558611,
      lng: 120.9575,
      distance: 0.4,
      split: [3, 10],
    },
    {
      name: '南向航行外航路',
      point: 3,
      lat: 25.174167,
      lng: 119.924444,
      distance: 0.4,
      split: [3, 10],
    },
    {
      name: '南向航行外航路',
      point: 4,
      lat: 23.5,
      lng: 117.819167,
      distance: 0.4,
      split: [3, 10],
    },
    {
      name: '北向航行外航路',
      point: 1,
      lat: 23.5,
      lng: 117.966111,
      distance: 0.4,
      split: [5, 10],
    },
    {
      name: '北向航行外航路',
      point: 2,
      lat: 25.115278,
      lng: 120.001389,
      distance: 0.4,
      split: [5, 10],
    },
    {
      name: '北向航行外航路',
      point: 3,
      lat: 26.558611,
      lng: 121.067778,
      distance: 0.4,
      split: [5, 10],
    },
    {
      name: '北向航行外航路',
      point: 4,
      lat: 27.0,
      lng: 121.325,
      distance: 0.4,
      split: [5, 10],
    },
    {
      name: '青岛港主航道',
      point: 1,
      lat: 35.94,
      lng: 120.778333,
      distance: 2.7,
      split: [1, 4],
      isSpec: true,
    },
    {
      name: '青岛港主航道',
      point: 2,
      lat: 36.034444,
      lng: 120.264167,
      distance: 2.7,
      split: [1, 4],
      isSpec: true,
    },
    {
      name: '第一航线',
      point: 1,
      lat: 36.292222,
      lng: 120.973889,
      distance: 1.8,
      split: [1, 4],
    },
    {
      name: '第一航线',
      point: 2,
      lat: 35.97,
      lng: 120.615,
      distance: 1.8,
      split: [1, 4],
    },
    {
      name: '第一预备航线',
      point: 1,
      lat: 36.117778,
      lng: 121.08,
      distance: 2,
      split: [1, 4],
    },
    {
      name: '第一预备航线',
      point: 2,
      lat: 35.97,
      lng: 120.615,
      distance: 2,
      split: [1, 4],
    },
    {
      name: '第二航线',
      point: 1,
      lat: 35.94,
      lng: 121.083333,
      distance: 3.2,
      split: [1, 4],
    },
    {
      name: '第二航线',
      point: 2,
      lat: 35.94,
      lng: 120.778333,
      distance: 3.2,
      split: [1, 4],
    },
    {
      name: '第三航线',
      point: 1,
      lat: 35.720833,
      lng: 120.885833,
      distance: 2.8,
      split: [1, 4],
    },
    {
      name: '第三航线',
      point: 2,
      lat: 35.94,
      lng: 120.778333,
      distance: 2.8,
      split: [1, 4],
    },
    {
      name: '第四航线',
      point: 1,
      lat: 35.75,
      lng: 120.108333,
      distance: 1,
      split: [3, 7],
    },
    {
      name: '第四航线',
      point: 2,
      lat: 35.953333,
      lng: 120.356667,
      distance: 1,
      split: [3, 7],
    },
    {
      name: '第四航线',
      point: 3,
      lat: 36.021667,
      lng: 120.333333,
      distance: 1,
      split: [3, 7],
    },
    {
      name: '崂山旅游航道',
      point: 1,
      lat: 36.056667,
      lng: 120.321667,
      distance: 0.108,
      split: [10, 19],
    },
    {
      name: '崂山旅游航道',
      point: 2,
      lat: 36.053333,
      lng: 120.313333,
      distance: 0.108,
      split: [10, 19],
    },
    {
      name: '崂山旅游航道',
      point: 3,
      lat: 36.0275,
      lng: 120.338333,
      distance: 0.108,
      split: [10, 19],
    },
    {
      name: '崂山旅游航道',
      point: 4,
      lat: 36.045,
      lng: 120.444667,
      distance: 0.108,
      split: [10, 19],
    },
    {
      name: '崂山旅游航道',
      point: 5,
      lat: 36.036333,
      lng: 120.594667,
      distance: 0.108,
      split: [10, 19],
    },
    {
      name: '崂山旅游航道',
      point: 6,
      lat: 36.125,
      lng: 120.683333,
      distance: 0.108,
      split: [10, 19],
    },
    {
      name: '崂山旅游航道',
      point: 7,
      lat: 36.133333,
      lng: 120.668333,
      distance: 0.108,
      split: [10, 19],
    },
    {
      name: '湛江港进出港航路',
      point: 1,
      lat: 20.406944,
      lng: 111.395,
      distance: 8,
      split: [1, 4],
    },
    {
      name: '湛江港进出港航路',
      point: 2,
      lat: 21.009444,
      lng: 110.995111,
      distance: 8,
      split: [1, 4],
    },
    {
      name: '茂名港进出港航路',
      point: 1,
      lat: 20.406944,
      lng: 111.395,
      distance: 8,
      split: [1, 4],
    },
    {
      name: '茂名港进出港航路',
      point: 2,
      lat: 21.140278,
      lng: 111.2925,
      distance: 8,
      split: [1, 4],
    },
    {
      name: '阳江港进出港航路',
      point: 1,
      lat: 20.575833,
      lng: 111.753611,
      distance: 8,
      split: [2, 7],
    },
    {
      name: '阳江港进出港航路',
      point: 2,
      lat: 21.195833,
      lng: 111.746667,
      distance: 8,
      split: [2, 7],
    },
    {
      name: '阳江港进出港航路',
      point: 3,
      lat: 21.536944,
      lng: 111.79,
      distance: 8,
      split: [2, 7],
    },
    {
      name: '珠海港进出港航路',
      point: 1,
      lat: 21.387778,
      lng: 113.487222,
      distance: 8,
      split: [1, 4],
    },
    {
      name: '珠海港进出港航路',
      point: 2,
      lat: 21.812222,
      lng: 113.226944,
      distance: 8,
      split: [1, 4],
    },
    {
      name: '珠江口桂山引航锚地至外航路',
      point: 1,
      lat: 22.122778,
      lng: 113.801389,
      distance: 6,
      split: [3, 10],
    },
    {
      name: '珠江口桂山引航锚地至外航路',
      point: 2,
      lat: 21.992222,
      lng: 113.871667,
      distance: 6,
      split: [3, 10],
    },
    {
      name: '珠江口桂山引航锚地至外航路',
      point: 3,
      lat: 21.93,
      lng: 113.862361,
      distance: 6,
      split: [3, 10],
    },
    {
      name: '珠江口桂山引航锚地至外航路',
      point: 4,
      lat: 21.5,
      lng: 113.733333,
      distance: 6,
      split: [3, 10],
    },
    {
      name: '珠江口蚊尾洲至外航路',
      point: 1,
      lat: 21.845556,
      lng: 113.836944,
      distance: 3,
      split: [3, 7],
    },
    {
      name: '珠江口蚊尾洲至外航路',
      point: 2,
      lat: 21.7075,
      lng: 113.956389,
      distance: 3,
      split: [3, 7],
    },
    {
      name: '珠江口蚊尾洲至外航路',
      point: 3,
      lat: 21.705,
      lng: 114.204167,
      distance: 3,
      split: [3, 7],
    },
    {
      name: '深圳盐田进出港航路',
      point: 1,
      lat: 21.753056,
      lng: 114.316667,
      distance: 6,
      split: [1, 4],
    },
    {
      name: '深圳盐田进出港航路',
      point: 2,
      lat: 22.395833,
      lng: 114.486111,
      distance: 6,
      split: [1, 4],
    },
    {
      name: '惠州港进出港航路',
      point: 1,
      lat: 21.959444,
      lng: 114.799722,
      distance: 6,
      split: [1, 4],
    },
    {
      name: '惠州港进出港航路',
      point: 2,
      lat: 22.491667,
      lng: 114.733056,
      distance: 6,
      split: [1, 4],
    },
    {
      name: '深汕合作区小漠港进出港航路',
      point: 1,
      lat: 22.168611,
      lng: 115.315833,
      distance: 6,
      split: [1, 4],
    },
    {
      name: '深汕合作区小漠港进出港航路',
      point: 2,
      lat: 22.651389,
      lng: 115.094167,
      distance: 6,
      split: [1, 4],
    },
    {
      name: '汕尾港进出港航路',
      point: 1,
      lat: 22.383056,
      lng: 115.966111,
      distance: 8,
      split: [1, 4],
    },
    {
      name: '汕尾港进出港航路',
      point: 2,
      lat: 22.696667,
      lng: 115.600556,
      distance: 8,
      split: [1, 4],
    },
    {
      name: '揭阳港进出港航路',
      point: 1,
      lat: 22.643889,
      lng: 116.758333,
      distance: 8,
      split: [1, 4],
    },
    {
      name: '揭阳港进出港航路',
      point: 2,
      lat: 22.903889,
      lng: 116.410556,
      distance: 8,
      split: [1, 4],
    },
    {
      name: '汕头港进出港航路',
      point: 1,
      lat: 23.012778,
      lng: 117.375,
      distance: 8,
      split: [1, 4],
    },
    {
      name: '汕头港进出港航路',
      point: 2,
      lat: 23.176944,
      lng: 116.792222,
      distance: 8,
      split: [1, 4],
    },
    {
      name: '潮州港进出港航路',
      point: 1,
      lat: 23.248611,
      lng: 117.586389,
      distance: 6,
      split: [2, 7],
    },
    {
      name: '潮州港进出港航路',
      point: 2,
      lat: 23.426389,
      lng: 117.221667,
      distance: 6,
      split: [2, 7],
    },
    {
      name: '潮州港进出港航路',
      point: 3,
      lat: 23.470833,
      lng: 117.19,
      distance: 6,
      split: [2, 7],
    },
    {
      name: '广东沿海外航路',
      split: [6, 13],
      point: 1,
      distance: 6,
      lat: 23.5,
      lng: 117.892778,
    },
    {
      name: '广东沿海外航路',
      split: [6, 13],
      point: 2,
      distance: 6,
      lat: 22.695,
      lng: 116.913889,
    },
    {
      name: '广东沿海外航路',
      split: [6, 13],
      point: 3,
      distance: 6,
      lat: 22.131389,
      lng: 115.202778,
    },
    {
      name: '广东沿海外航路',
      split: [6, 13],
      point: 4,
      distance: 6,
      lat: 21.49,
      lng: 113.701667,
    },
    {
      name: '广东沿海外航路',
      split: [6, 13],
      point: 5,
      distance: 6,
      lat: 20.256389,
      lng: 111.075556,
    },
    {
      name: '粤东沿海南澎列岛南至外航路',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 23.200278,
      lng: 117.349167,
    },
    {
      name: '粤东沿海南澎列岛南至外航路',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 22.643889,
      lng: 116.758333,
    },
    {
      name: '珠江口担杆水道至外航路',
      split: [1, 4],
      point: 1,
      distance: 3,
      lat: 22.119444,
      lng: 114.379167,
    },
    {
      name: '珠江口担杆水道至外航路',
      split: [1, 4],
      point: 2,
      distance: 3,
      lat: 22.131389,
      lng: 115.202778,
    },
    {
      name: '广东沿海内航路',
      split: [11, 28],
      point: 1,
      distance: 3,
      lat: 23.5,
      lng: 117.518056,
    },
    {
      name: '广东沿海内航路',
      split: [11, 28],
      point: 2,
      distance: 3,
      lat: 23.244444,
      lng: 117.213611,
    },
    {
      name: '广东沿海内航路',
      split: [11, 28],
      point: 3,
      distance: 3,
      lat: 22.763333,
      lng: 116.362778,
    },
    {
      name: '广东沿海内航路',
      split: [11, 28],
      point: 4,
      distance: 3,
      lat: 22.600833,
      lng: 115.87,
    },
    {
      name: '广东沿海内航路',
      split: [11, 28],
      point: 5,
      distance: 3,
      lat: 22.412222,
      lng: 114.950833,
    },
    {
      name: '广东沿海内航路',
      split: [11, 28],
      point: 6,
      distance: 3,
      lat: 22.119444,
      lng: 114.379167,
    },
    {
      name: '广东沿海内航路',
      split: [11, 28],
      point: 7,
      distance: 3,
      lat: 21.93,
      lng: 113.862361,
    },
    {
      name: '广东沿海内航路',
      split: [11, 28],
      point: 8,
      distance: 3,
      lat: 21.488889,
      lng: 112.849167,
    },
    {
      name: '广东沿海内航路',
      split: [11, 28],
      point: 9,
      distance: 3,
      lat: 21.111667,
      lng: 111.429444,
    },
    {
      name: '广东沿海内航路',
      split: [11, 28],
      point: 10,
      distance: 3,
      lat: 21.009444,
      lng: 110.995111,
    },
    {
      name: '粤东沿海南澎列岛南至石碑山角',
      split: [2, 7],
      point: 1,
      distance: 1,
      lat: 23.5,
      lng: 117.726944,
    },
    {
      name: '粤东沿海南澎列岛南至石碑山角',
      split: [2, 7],
      point: 2,
      distance: 1,
      lat: 23.200278,
      lng: 117.349167,
    },
    {
      name: '粤东沿海南澎列岛南至石碑山角',
      split: [2, 7],
      point: 3,
      distance: 1,
      lat: 22.913889,
      lng: 116.628611,
    },
    {
      name: '粤西沿海江门上川岛南至琼州海峡北水道',
      split: [2, 7],
      point: 1,
      distance: 3,
      lat: 21.488889,
      lng: 112.849167,
    },
    {
      name: '粤西沿海江门上川岛南至琼州海峡北水道',
      split: [2, 7],
      point: 2,
      distance: 3,
      lat: 20.867778,
      lng: 111.664722,
    },
    {
      name: '粤西沿海江门上川岛南至琼州海峡北水道',
      split: [2, 7],
      point: 3,
      distance: 3,
      lat: 20.516667,
      lng: 110.943889,
    },
    {
      name: '粤西沿海茂名港外至琼州海峡北水道',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.111667,
      lng: 111.429444,
    },
    {
      name: '粤西沿海茂名港外至琼州海峡北水道',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 20.516667,
      lng: 110.943889,
    },
    {
      name: '粤东沿海近岸航路',
      split: [7, 16],
      point: 1,
      distance: 1,
      lat: 23.5,
      lng: 117.358889,
    },
    {
      name: '粤东沿海近岸航路',
      split: [7, 16],
      point: 2,
      distance: 1,
      lat: 23.385,
      lng: 117.129722,
    },
    {
      name: '粤东沿海近岸航路',
      split: [7, 16],
      point: 3,
      distance: 1,
      lat: 23.352778,
      lng: 117.048611,
    },
    {
      name: '粤东沿海近岸航路',
      split: [7, 16],
      point: 4,
      distance: 1,
      lat: 23.194444,
      lng: 116.843889,
    },
    {
      name: '粤东沿海近岸航路',
      split: [7, 16],
      point: 5,
      distance: 1,
      lat: 22.899167,
      lng: 116.513889,
    },
    {
      name: '粤东沿海近岸航路',
      split: [7, 16],
      point: 6,
      distance: 1,
      lat: 22.270556,
      lng: 114.502778,
    },
    {
      name: '汕头南澳岛南至汕头港进港航道口门',
      split: [1, 4],
      point: 1,
      distance: 1,
      lat: 23.352778,
      lng: 117.048611,
    },
    {
      name: '汕头南澳岛南至汕头港进港航道口门',
      split: [1, 4],
      point: 2,
      distance: 1,
      lat: 23.276111,
      lng: 116.802222,
    },
    {
      name: '汕尾遮浪角至深圳大鹏湾',
      split: [6, 13],
      point: 1,
      distance: 2,
      lat: 22.621944,
      lng: 115.615833,
    },
    {
      name: '汕尾遮浪角至深圳大鹏湾',
      split: [6, 13],
      point: 2,
      distance: 2,
      lat: 22.573611,
      lng: 115.028611,
    },
    {
      name: '汕尾遮浪角至深圳大鹏湾',
      split: [6, 13],
      point: 3,
      distance: 2,
      lat: 22.524167,
      lng: 114.842222,
    },
    {
      name: '汕尾遮浪角至深圳大鹏湾',
      split: [6, 13],
      point: 4,
      distance: 2,
      lat: 22.475833,
      lng: 114.595,
    },
    {
      name: '汕尾遮浪角至深圳大鹏湾',
      split: [6, 13],
      point: 5,
      distance: 2,
      lat: 22.395833,
      lng: 114.486111,
    },
    {
      name: '珠江口桂山岛经东澳岛至江门上川岛南',
      split: [2, 7],
      point: 1,
      distance: 2,
      lat: 22.122778,
      lng: 113.801389,
    },
    {
      name: '珠江口桂山岛经东澳岛至江门上川岛南',
      split: [2, 7],
      point: 2,
      distance: 2,
      lat: 22.011389,
      lng: 113.735278,
    },
    {
      name: '珠江口桂山岛经东澳岛至江门上川岛南',
      split: [2, 7],
      point: 3,
      distance: 2,
      lat: 21.488889,
      lng: 112.849167,
    },
    {
      name: '珠江口东澳水道',
      split: [1, 4],
      point: 1,
      distance: 1,
      lat: 22.011389,
      lng: 113.735278,
    },
    {
      name: '珠江口东澳水道',
      split: [1, 4],
      point: 2,
      distance: 1,
      lat: 22.051389,
      lng: 113.86,
    },
    {
      name: '珠江口大蜘洲至江门上川岛南',
      split: [5, 10],
      point: 1,
      distance: 2,
      lat: 22.097778,
      lng: 113.849167,
    },
    {
      name: '珠江口大蜘洲至江门上川岛南',
      split: [5, 10],
      point: 2,
      distance: 2,
      lat: 22.076389,
      lng: 113.696111,
    },
    {
      name: '珠江口大蜘洲至江门上川岛南',
      split: [5, 10],
      point: 3,
      distance: 2,
      lat: 21.838056,
      lng: 113.236667,
    },
    {
      name: '珠江口大蜘洲至江门上川岛南',
      split: [5, 10],
      point: 4,
      distance: 2,
      lat: 21.488889,
      lng: 112.849167,
    },
    {
      name: '珠江口珠海高栏港至蚊尾洲',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.838056,
      lng: 113.236667,
    },
    {
      name: '珠江口珠海高栏港至蚊尾洲',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.845556,
      lng: 113.836944,
    },
    {
      name: '珠江口大西水道',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 22.120556,
      lng: 113.655556,
    },
    {
      name: '珠江口大西水道',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.8875,
      lng: 113.525,
    },
    {
      name: '珠江口大头洲至澳门水道',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 22.076389,
      lng: 113.696111,
    },
    {
      name: '珠江口大头洲至澳门水道',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 22.166389,
      lng: 113.613333,
    },
    {
      name: '珠海高栏港外至阳江南鹏岛北',
      split: [6, 13],
      point: 1,
      distance: 1,
      lat: 21.838056,
      lng: 113.236667,
    },
    {
      name: '珠海高栏港外至阳江南鹏岛北',
      split: [6, 13],
      point: 2,
      distance: 1,
      lat: 21.786111,
      lng: 112.763889,
    },
    {
      name: '珠海高栏港外至阳江南鹏岛北',
      split: [6, 13],
      point: 3,
      distance: 1,
      lat: 21.716111,
      lng: 112.588333,
    },
    {
      name: '珠海高栏港外至阳江南鹏岛北',
      split: [6, 13],
      point: 4,
      distance: 1,
      lat: 21.619167,
      lng: 112.464167,
    },
    {
      name: '珠海高栏港外至阳江南鹏岛北',
      split: [6, 13],
      point: 5,
      distance: 1,
      lat: 21.582778,
      lng: 112.232222,
    },
    {
      name: '粤西沿海近岸航路',
      split: [7, 13],
      point: 1,
      distance: 2,
      lat: 21.5225,
      lng: 112.906389,
    },
    {
      name: '粤西沿海近岸航路',
      split: [7, 13],
      point: 2,
      distance: 2,
      lat: 21.582778,
      lng: 112.232222,
    },
    {
      name: '粤西沿海近岸航路',
      split: [7, 13],
      point: 3,
      distance: 2,
      lat: 21.575,
      lng: 112.097222,
    },
    {
      name: '粤西沿海近岸航路',
      split: [7, 13],
      point: 4,
      distance: 2,
      lat: 21.376667,
      lng: 111.39,
    },
    {
      name: '粤西沿海近岸航路',
      split: [7, 13],
      point: 5,
      distance: 2,
      lat: 21.046389,
      lng: 110.666111,
    },
    {
      name: '湛江港外至琼州海峡北水道',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.031111,
      lng: 110.786667,
    },
    {
      name: '湛江港外至琼州海峡北水道',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 20.516667,
      lng: 110.943889,
    },
    {
      name: '茂名博贺至湛江外罗',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.376667,
      lng: 111.39,
    },
    {
      name: '茂名博贺至湛江外罗',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 20.6575,
      lng: 110.611389,
    },
    {
      name: '外航路',
      split: [4, 10],
      point: 1,
      distance: 6,
      lat: 30.733333,
      lng: 123.266667,
    },
    {
      name: '外航路',
      split: [4, 10],
      point: 2,
      distance: 6,
      lat: 30.166667,
      lng: 123,
    },
    {
      name: '外航路',
      split: [4, 10],
      point: 3,
      distance: 6,
      lat: 28.883333,
      lng: 122.583333,
    },
    {
      name: '外航路',
      split: [4, 10],
      point: 4,
      distance: 6,
      lat: 27,
      lng: 121.291667,
    },
    {
      name: '外航路支线',
      split: [1, 4],
      point: 1,
      distance: 3,
      lat: 30.783333,
      lng: 123,
    },
    {
      name: '外航路支线',
      split: [1, 4],
      point: 2,
      distance: 3,
      lat: 30.166667,
      lng: 123,
    },
    {
      name: '东航路',
      split: [8, 19],
      point: 1,
      distance: 4,
      lat: 30.86,
      lng: 122.533333,
    },
    {
      name: '东航路',
      split: [8, 19],
      point: 2,
      distance: 4,
      lat: 30.67,
      lng: 122.631667,
    },
    {
      name: '东航路',
      split: [8, 19],
      point: 3,
      distance: 4,
      lat: 30.2,
      lng: 122.608333,
    },
    {
      name: '东航路',
      split: [8, 19],
      point: 4,
      distance: 4,
      lat: 29.656667,
      lng: 122.680833,
    },
    {
      name: '东航路',
      split: [8, 19],
      point: 5,
      distance: 4,
      lat: 28.708333,
      lng: 122.045,
    },
    {
      name: '东航路',
      split: [8, 19],
      point: 6,
      distance: 4,
      lat: 28.4,
      lng: 122.008333,
    },
    {
      name: '东航路',
      split: [8, 19],
      point: 7,
      distance: 4,
      lat: 27,
      lng: 120.893333,
    },
    {
      name: '东航路支线',
      split: [3, 7],
      point: 1,
      distance: 2,
      lat: 30.816667,
      lng: 122.325,
    },
    {
      name: '东航路支线',
      split: [3, 7],
      point: 2,
      distance: 2,
      lat: 30.633333,
      lng: 122.358333,
    },
    {
      name: '东航路支线',
      split: [3, 7],
      point: 3,
      distance: 2,
      lat: 30.491667,
      lng: 122.621667,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 1,
      distance: 2,
      lat: 30.808333,
      lng: 122.305,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 2,
      distance: 2,
      lat: 30.546667,
      lng: 122.185,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 3,
      distance: 2,
      lat: 30.52,
      lng: 121.965,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 4,
      distance: 2,
      lat: 30.353333,
      lng: 121.773333,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 5,
      distance: 2,
      lat: 30.116667,
      lng: 121.88,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 6,
      distance: 2,
      lat: 30.085,
      lng: 121.899667,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 7,
      distance: 2,
      lat: 30.07,
      lng: 121.910833,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 8,
      distance: 2,
      lat: 30.056167,
      lng: 121.9245,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 9,
      distance: 2,
      lat: 30.038167,
      lng: 121.939,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 10,
      distance: 2,
      lat: 29.971667,
      lng: 121.973333,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 11,
      distance: 2,
      lat: 29.922833,
      lng: 122.026333,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 12,
      distance: 2,
      lat: 29.922833,
      lng: 122.1285,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 13,
      distance: 2,
      lat: 29.88,
      lng: 122.151667,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 14,
      distance: 2,
      lat: 29.844,
      lng: 122.126167,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 15,
      distance: 2,
      lat: 29.782,
      lng: 122.063,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 16,
      distance: 2,
      lat: 29.7635,
      lng: 122.061,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 17,
      distance: 2,
      lat: 29.734333,
      lng: 122.047833,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 18,
      distance: 2,
      lat: 29.71,
      lng: 122.030333,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 19,
      distance: 2,
      lat: 29.565,
      lng: 122.111667,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 20,
      distance: 2,
      lat: 29.115,
      lng: 122.111667,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 21,
      distance: 2,
      lat: 28.76,
      lng: 122.016667,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 22,
      distance: 2,
      lat: 28.463333,
      lng: 121.806667,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 23,
      distance: 2,
      lat: 28.243333,
      lng: 121.758333,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 24,
      distance: 2,
      lat: 27.725,
      lng: 121.241667,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 25,
      distance: 2,
      lat: 27.636667,
      lng: 121.096667,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 26,
      distance: 2,
      lat: 27.45,
      lng: 120.9,
    },
    {
      name: '西航路',
      split: [38, 79],
      point: 27,
      distance: 2,
      lat: 27.086667,
      lng: 120.603333,
    },
    {
      name: '西航路支线',
      split: [10, 19],
      point: 1,
      distance: 1,
      lat: 30.353333,
      lng: 121.773333,
    },
    {
      name: '西航路支线',
      split: [10, 19],
      point: 2,
      distance: 1,
      lat: 30.1,
      lng: 121.803333,
    },
    {
      name: '西航路支线',
      split: [10, 19],
      point: 3,
      distance: 1,
      lat: 29.995,
      lng: 121.8075,
    },
    {
      name: '西航路支线',
      split: [10, 19],
      point: 4,
      distance: 1,
      lat: 29.965,
      lng: 121.843333,
    },
    {
      name: '西航路支线',
      split: [10, 19],
      point: 5,
      distance: 1,
      lat: 29.956667,
      lng: 121.86,
    },
    {
      name: '西航路支线',
      split: [10, 19],
      point: 6,
      distance: 1,
      lat: 29.961667,
      lng: 121.933333,
    },
    {
      name: '西航路支线',
      split: [10, 19],
      point: 7,
      distance: 1,
      lat: 29.971667,
      lng: 121.973333,
    },
    {
      name: '舟山北部进港航路',
      split: [4, 14, 24],
      point: 1,
      distance: 1,
      lat: 30.261667,
      lng: 123.061667,
    },
    {
      name: '舟山北部进港航路',
      split: [4, 14, 24],
      point: 2,
      distance: 1,
      lat: 30.62,
      lng: 122.51,
    },
    {
      name: '舟山北部进港航路',
      split: [4, 14, 24],
      point: 3,
      distance: 1,
      lat: 30.661833,
      lng: 122.413333,
    },
    {
      name: '舟山北部进港航路',
      split: [4, 14, 24],
      point: 4,
      distance: 1,
      lat: 30.7,
      lng: 122.336667,
    },
    {
      name: '舟山北部进港航路',
      split: [4, 14, 24],
      point: 5,
      distance: 1,
      lat: 30.470167,
      lng: 122.740833,
    },
    {
      name: '舟山北部进港航路',
      split: [4, 14, 24],
      point: 6,
      distance: 1,
      lat: 30.526667,
      lng: 122.425,
    },
    {
      name: '舟山北部进港航路',
      split: [4, 14, 24],
      point: 7,
      distance: 1,
      lat: 30.557667,
      lng: 122.201667,
    },
    {
      name: '舟山北部进港航路',
      split: [4, 14, 24],
      point: 8,
      distance: 1,
      lat: 30.546667,
      lng: 122.185,
    },
    {
      name: '舟山北部进港航路',
      split: [4, 14, 24],
      point: 9,
      distance: 1,
      lat: 30.4895,
      lng: 121.711333,
    },
    {
      name: '舟山北部进港航路',
      split: [4, 14, 24],
      point: 10,
      distance: 1,
      lat: 30.561667,
      lng: 121.359333,
    },
    {
      name: '舟山中北部进港航路',
      split: [8, 19],
      point: 1,
      distance: 1,
      lat: 30.339167,
      lng: 122.941667,
    },
    {
      name: '舟山中北部进港航路',
      split: [8, 19],
      point: 2,
      distance: 1,
      lat: 30.339167,
      lng: 122.686667,
    },
    {
      name: '舟山中北部进港航路',
      split: [8, 19],
      point: 3,
      distance: 1,
      lat: 30.374167,
      lng: 122.615,
    },
    {
      name: '舟山中北部进港航路',
      split: [8, 19],
      point: 4,
      distance: 1,
      lat: 30.373167,
      lng: 122.311667,
    },
    {
      name: '舟山中北部进港航路',
      split: [8, 19],
      point: 5,
      distance: 1,
      lat: 30.375833,
      lng: 122.021667,
    },
    {
      name: '舟山中北部进港航路',
      split: [8, 19],
      point: 6,
      distance: 1,
      lat: 30.396667,
      lng: 121.866667,
    },
    {
      name: '舟山中北部进港航路',
      split: [8, 19],
      point: 7,
      distance: 1,
      lat: 30.353333,
      lng: 121.773333,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 12,
      distance: 1,
      lat: 30.353333,
      lng: 121.773333,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 11,
      distance: 1,
      lat: 30.283333,
      lng: 121.825,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 10,
      distance: 1,
      lat: 30.263333,
      lng: 121.925,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 9,
      distance: 1,
      lat: 30.206667,
      lng: 122.058333,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 8,
      distance: 1,
      lat: 30.187833,
      lng: 122.081,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 7,
      distance: 1,
      lat: 30.176667,
      lng: 122.081167,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 6,
      distance: 1,
      lat: 30.167833,
      lng: 122.089,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 5,
      distance: 1,
      lat: 30.1575,
      lng: 122.126333,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 4,
      distance: 1,
      lat: 30.121167,
      lng: 122.163667,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 3,
      distance: 1,
      lat: 30.120167,
      lng: 122.1865,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 2,
      distance: 1,
      lat: 30.121,
      lng: 122.3355,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 1,
      distance: 1,
      lat: 30.034833,
      lng: 122.582,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 13,
      distance: 1,
      lat: 30.121,
      lng: 122.3355,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 14,
      distance: 1,
      lat: 30.183667,
      lng: 122.291167,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 15,
      distance: 1,
      lat: 30.211,
      lng: 122.253833,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 16,
      distance: 1,
      lat: 30.213167,
      lng: 122.240167,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 17,
      distance: 1,
      lat: 30.211667,
      lng: 122.187,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 18,
      distance: 1,
      lat: 30.212667,
      lng: 122.1625,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 19,
      distance: 1,
      lat: 30.196,
      lng: 122.090167,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 20,
      distance: 1,
      lat: 30.187833,
      lng: 122.081,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 21,
      distance: 1,
      lat: 30.176667,
      lng: 122.081167,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 22,
      distance: 1,
      lat: 30.157167,
      lng: 122.0625,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 23,
      distance: 1,
      lat: 30.157167,
      lng: 122.027,
    },
    {
      name: '舟山中部进港航路',
      split: [10, 26, 48],
      point: 24,
      distance: 1,
      lat: 30.167333,
      lng: 122.003,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 19,
      distance: 1,
      lat: 29.852667,
      lng: 122.200333,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 18,
      distance: 1,
      lat: 29.8405,
      lng: 122.181,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 17,
      distance: 1,
      lat: 29.812667,
      lng: 122.129667,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 16,
      distance: 1,
      lat: 29.750667,
      lng: 122.178333,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 15,
      distance: 1,
      lat: 29.732333,
      lng: 122.217333,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 14,
      distance: 1,
      lat: 29.688667,
      lng: 122.3155,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 13,
      distance: 1,
      lat: 29.6895,
      lng: 122.508833,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 1,
      distance: 1,
      lat: 29.687667,
      lng: 122.522833,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 2,
      distance: 1,
      lat: 29.738333,
      lng: 122.3305,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 3,
      distance: 1,
      lat: 29.805833,
      lng: 122.239833,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 4,
      distance: 1,
      lat: 29.832333,
      lng: 122.213833,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 5,
      distance: 1,
      lat: 29.852667,
      lng: 122.200333,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 6,
      distance: 1,
      lat: 29.922833,
      lng: 122.160667,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 7,
      distance: 1,
      lat: 29.922833,
      lng: 122.026333,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 8,
      distance: 1,
      lat: 29.971667,
      lng: 121.973333,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 9,
      distance: 1,
      lat: 29.961667,
      lng: 121.933333,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 10,
      distance: 1,
      lat: 29.956667,
      lng: 121.86,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 11,
      distance: 1,
      lat: 29.965,
      lng: 121.843333,
    },
    {
      name: '宁波舟山港核心港区',
      split: [11, 26],
      point: 12,
      distance: 1,
      lat: 29.995,
      lng: 121.8075,
    },
    {
      name: '台州湾进港北航路',
      split: [3, 10],
      point: 1,
      distance: 1,
      lat: 28.881667,
      lng: 122.043333,
    },
    {
      name: '台州湾进港北航路',
      split: [3, 10],
      point: 2,
      distance: 1,
      lat: 28.736667,
      lng: 121.903333,
    },
    {
      name: '台州湾进港北航路',
      split: [3, 10],
      point: 3,
      distance: 1,
      lat: 28.666667,
      lng: 121.775,
    },
    {
      name: '台州湾进港北航路',
      split: [3, 10],
      point: 4,
      distance: 1,
      lat: 28.666667,
      lng: 121.66,
    },
    {
      name: '台州湾进港南航路',
      split: [1, 4],
      point: 1,
      distance: 1,
      lat: 28.386667,
      lng: 121.788333,
    },
    {
      name: '台州湾进港南航路',
      split: [1, 4],
      point: 2,
      distance: 1,
      lat: 28.666667,
      lng: 121.66,
    },
    {
      name: '乐清湾进港北航路',
      split: [1, 4],
      point: 1,
      distance: 1,
      lat: 28.016667,
      lng: 121.528833,
    },
    {
      name: '乐清湾进港北航路',
      split: [1, 4],
      point: 2,
      distance: 1,
      lat: 28.031333,
      lng: 121.212333,
    },
    {
      name: '乐清湾进港南航路',
      split: [1, 4],
      point: 1,
      distance: 1,
      lat: 27.876667,
      lng: 121.382167,
    },
    {
      name: '乐清湾进港南航路',
      split: [1, 4],
      point: 2,
      distance: 1,
      lat: 28.031333,
      lng: 121.212333,
    },
    {
      name: '温州港核心港区进港航路',
      split: [1, 4],
      point: 1,
      distance: 1,
      lat: 27.816833,
      lng: 121.328833,
    },
    {
      name: '温州港核心港区进港航路',
      split: [1, 4],
      point: 2,
      distance: 1,
      lat: 27.922,
      lng: 121.207667,
    },
    {
      name: '成山角一长山水道航路',
      split: [2, 7],
      point: 1,
      distance: 13,
      lat: 37.652778,
      lng: 122.670833,
    },
    {
      name: '成山角一长山水道航路',
      split: [2, 7],
      point: 2,
      distance: 13,
      lat: 37.880556,
      lng: 121.414722,
    },
    {
      name: '成山角一长山水道航路',
      split: [2, 7],
      point: 3,
      distance: 13,
      lat: 37.946111,
      lng: 121.120556,
    },
    {
      name: '成山角一丹东航路',
      split: [2, 7],
      point: 1,
      distance: 3,
      lat: 37.616667,
      lng: 123.0,
    },
    {
      name: '成山角一丹东航路',
      split: [2, 7],
      point: 2,
      distance: 3,
      lat: 38.933333,
      lng: 123.416667,
    },
    {
      name: '成山角一丹东航路',
      split: [2, 7],
      point: 3,
      distance: 3,
      lat: 39.343611,
      lng: 123.788611,
    },
    {
      name: '威海一丹东航路',
      split: [2, 7],
      point: 1,
      distance: 3,
      lat: 37.574444,
      lng: 122.308333,
    },
    {
      name: '威海一丹东航路',
      split: [2, 7],
      point: 2,
      distance: 3,
      lat: 38.933333,
      lng: 123.416667,
    },
    {
      name: '威海一丹东航路',
      split: [2, 7],
      point: 3,
      distance: 3,
      lat: 39.343611,
      lng: 123.788611,
    },
    {
      name: '成山角一老铁山水道航路',
      split: [1, 4],
      point: 1,
      distance: 15,
      lat: 37.659722,
      lng: 122.702222,
    },
    {
      name: '成山角一老铁山水道航路',
      split: [1, 4],
      point: 2,
      distance: 15,
      lat: 38.497778,
      lng: 121.097778,
    },
    {
      name: '成山角一大连航路',
      split: [1, 4],
      point: 1,
      distance: 15,
      lat: 37.659722,
      lng: 122.723611,
    },
    {
      name: '成山角一大连航路',
      split: [1, 4],
      point: 2,
      distance: 15,
      lat: 38.75,
      lng: 121.861389,
    },
    {
      name: '威海一大连航路',
      split: [1, 4],
      point: 1,
      distance: 3,
      lat: 37.575278,
      lng: 122.258333,
    },
    {
      name: '威海一大连航路',
      split: [1, 4],
      point: 2,
      distance: 3,
      lat: 38.75,
      lng: 121.798056,
    },
    {
      name: '烟台(长山水道)一大连航路',
      split: [1, 4],
      point: 1,
      distance: 1,
      lat: 38.5,
      lng: 121.711111,
    },
    {
      name: '烟台(长山水道)一大连航路',
      split: [1, 4],
      point: 2,
      distance: 1,
      lat: 38.750556,
      lng: 121.781389,
    },
    {
      name: '烟台一大连航路',
      split: [1, 4],
      point: 1,
      distance: 3,
      lat: 37.771944,
      lng: 121.514722,
    },
    {
      name: '烟台一大连航路',
      split: [1, 4],
      point: 2,
      distance: 3,
      lat: 38.750556,
      lng: 121.781389,
    },
    {
      name: '老铁山水道一烟台航路',
      split: [1, 4],
      point: 1,
      distance: 3,
      lat: 38.497778,
      lng: 121.097778,
    },
    {
      name: '老铁山水道一烟台航路',
      split: [1, 4],
      point: 2,
      distance: 3,
      lat: 37.776944,
      lng: 121.424167,
    },
    {
      name: '老铁山水道一曹妃甸深水航路',
      split: [3, 7],
      point: 1,
      distance: 0.54,
      lat: 38.629722,
      lng: 120.753611,
    },
    {
      name: '老铁山水道一曹妃甸深水航路',
      split: [3, 7],
      point: 2,
      distance: 0.54,
      lat: 38.8,
      lng: 119.166667,
    },
    {
      name: '老铁山水道一曹妃甸深水航路',
      split: [3, 7],
      point: 3,
      distance: 0.54,
      lat: 38.8,
      lng: 118.753333,
    },
    {
      name: '长山水道一曹妃甸航路',
      split: [2, 7],
      point: 1,
      distance: 4.4,
      lat: 38.114617,
      lng: 120.311944,
      isDiff: true,
    },
    {
      name: '长山水道一曹妃甸航路',
      split: [2, 7],
      point: 2,
      distance: 4.4,
      lat: 38.727222,
      lng: 119.0,
      isDiff: true,
    },
    {
      name: '长山水道一曹妃甸航路',
      split: [2, 7],
      point: 3,
      distance: 3,
      lat: 38.790278,
      lng: 118.864722,
      isDiff: true,
    },
    {
      name: '老铁山水道一天津航路',
      split: [2, 7],
      point: 1,
      distance: 6,
      lat: 38.611389,
      lng: 120.749722,
      isDiff: true,
    },
    {
      name: '老铁山水道一天津航路',
      split: [2, 7],
      point: 2,
      distance: 4.8,
      lat: 38.776667,
      lng: 119.0,
      isDiff: true,
    },
    {
      name: '老铁山水道一天津航路',
      split: [2, 7],
      point: 3,
      distance: 4.8,
      lat: 38.8,
      lng: 118.753333,
      isDiff: true,
    },
    {
      name: '老铁山水道一黄骅航路',
      split: [1, 4],
      point: 1,
      distance: 2.5,
      lat: 38.619167,
      lng: 120.750833,
    },
    {
      name: '老铁山水道一黄骅航路',
      split: [1, 4],
      point: 2,
      distance: 2.5,
      lat: 38.653611,
      lng: 118.704444,
    },
    {
      name: '老铁山水道一京唐航路',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 38.635,
      lng: 120.756944,
    },
    {
      name: '老铁山水道一京唐航路',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 39.034444,
      lng: 119.337778,
    },
    {
      name: '长山水道一京唐航路',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 38.114722,
      lng: 120.312778,
    },
    {
      name: '长山水道一京唐航路',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 38.904722,
      lng: 119.326111,
    },
    {
      name: '老铁山水道一秦皇岛航路',
      split: [3, 7],
      point: 1,
      distance: 6,
      lat: 38.685556,
      lng: 120.823889,
    },
    {
      name: '老铁山水道一秦皇岛航路',
      split: [3, 7],
      point: 2,
      distance: 6,
      lat: 38.908333,
      lng: 120.693333,
    },
    {
      name: '老铁山水道一秦皇岛航路',
      split: [3, 7],
      point: 3,
      distance: 6,
      lat: 39.523056,
      lng: 120.030278,
    },
    {
      name: '长山水道一大连航路',
      split: [3, 7],
      point: 1,
      distance: 3,
      lat: 38.011667,
      lng: 121.101389,
    },
    {
      name: '长山水道一大连航路',
      split: [3, 7],
      point: 2,
      distance: 3,
      lat: 38.4,
      lng: 121.683333,
    },
    {
      name: '长山水道一大连航路',
      split: [3, 7],
      point: 3,
      distance: 3,
      lat: 38.750556,
      lng: 121.781389,
    },
    {
      name: '长山水道一老铁山水道航路',
      split: [3, 10],
      point: 1,
      distance: 3,
      lat: 38.028333,
      lng: 120.999444,
    },
    {
      name: '长山水道一老铁山水道航路',
      split: [3, 10],
      point: 2,
      distance: 3,
      lat: 38.114444,
      lng: 121.016944,
    },
    {
      name: '长山水道一老铁山水道航路',
      split: [3, 10],
      point: 3,
      distance: 3,
      lat: 38.497778,
      lng: 121.097778,
    },
    {
      name: '长山水道一老铁山水道航路',
      split: [3, 10],
      point: 4,
      distance: 3,
      lat: 38.750556,
      lng: 121.781389,
    },
    {
      name: '秦皇岛一天津航路',
      split: [2, 7],
      point: 1,
      distance: 2.5,
      lat: 39.6625,
      lng: 119.733333,
    },
    {
      name: '秦皇岛一天津航路',
      split: [2, 7],
      point: 2,
      distance: 2.5,
      lat: 39.333333,
      lng: 119.733333,
    },
    {
      name: '秦皇岛一天津航路',
      split: [2, 7],
      point: 3,
      distance: 2.5,
      lat: 38.748333,
      lng: 119.294444,
    },
    {
      name: '秦皇岛一莱州航路',
      split: [2, 7],
      point: 1,
      distance: 2,
      lat: 39.6625,
      lng: 119.733333,
    },
    {
      name: '秦皇岛一莱州航路',
      split: [2, 7],
      point: 2,
      distance: 2,
      lat: 39.3,
      lng: 120.0,
    },
    {
      name: '秦皇岛一莱州航路',
      split: [2, 7],
      point: 3,
      distance: 2,
      lat: 38.065556,
      lng: 119.884722,
    },
    {
      name: '老铁山水道一营口仙人岛深水航路',
      split: [3, 10],
      point: 1,
      distance: 0.54,
      lat: 38.676944,
      lng: 120.8,
    },
    {
      name: '老铁山水道一营口仙人岛深水航路',
      split: [3, 10],
      point: 2,
      distance: 0.54,
      lat: 39.52,
      lng: 120.8,
    },
    {
      name: '老铁山水道一营口仙人岛深水航路',
      split: [3, 10],
      point: 3,
      distance: 0.54,
      lat: 39.91,
      lng: 121.245,
    },
    {
      name: '老铁山水道一营口仙人岛深水航路',
      split: [3, 10],
      point: 4,
      distance: 0.54,
      lat: 40.0675,
      lng: 121.5,
    },
    {
      name: '老铁山水道一渤海北部航路',
      split: [13, 5],
      point: 1,
      distance: 6,
      lat: 38.689167,
      lng: 120.856944,
    },
    {
      name: '老铁山水道一渤海北部航路',
      split: [13, 5],
      point: 2,
      distance: 6,
      lat: 38.933611,
      lng: 120.856944,
    },
    {
      name: '老铁山水道一渤海北部航路',
      split: [13, 5],
      point: 3,
      distance: 6,
      lat: 39.073611,
      lng: 120.875278,
    },
    {
      name: '老铁山水道一渤海北部航路',
      split: [13, 5],
      point: 4,
      distance: 6,
      lat: 39.5,
      lng: 120.931389,
    },
    {
      name: '老铁山水道一渤海北部航路',
      split: [13, 5],
      point: 5,
      distance: 6,
      lat: 39.963611,
      lng: 121.379167,
    },
    {
      name: '渤海北部-锦州2号锚地航路',
      split: [3, 7],
      point: 1,
      distance: 3,
      lat: 39.963611,
      lng: 121.379167,
    },
    {
      name: '渤海北部-锦州2号锚地航路',
      split: [3, 7],
      point: 2,
      distance: 3,
      lat: 40.246944,
      lng: 121.449722,
    },
    {
      name: '渤海北部-锦州2号锚地航路',
      split: [3, 7],
      point: 3,
      distance: 3,
      lat: 40.557108,
      lng: 121.447222,
    },
    {
      name: '渤海北部一锦州3号锚地航路',
      split: [3, 7],
      point: 1,
      distance: 3,
      lat: 39.963611,
      lng: 121.379167,
    },
    {
      name: '渤海北部一锦州3号锚地航路',
      split: [3, 7],
      point: 2,
      distance: 3,
      lat: 40.153889,
      lng: 121.426389,
    },
    {
      name: '渤海北部一锦州3号锚地航路',
      split: [3, 7],
      point: 3,
      distance: 3,
      lat: 40.234722,
      lng: 121.375556,
    },
    {
      name: '渤海北部一营口航路',
      split: [10, 3],
      point: 1,
      distance: 3,
      lat: 39.963611,
      lng: 121.379167,
    },
    {
      name: '渤海北部一营口航路',
      split: [10, 3],
      point: 2,
      distance: 3,
      lat: 40.153889,
      lng: 121.426389,
    },
    {
      name: '渤海北部一营口航路',
      split: [10, 3],
      point: 3,
      distance: 3,
      lat: 40.291389,
      lng: 121.644167,
    },
    {
      name: '渤海北部一营口航路',
      split: [10, 3],
      point: 4,
      distance: 3,
      lat: 40.291389,
      lng: 121.812778,
    },
    {
      name: '渤海北部一盘锦航路',
      split: [10, 4],
      point: 1,
      distance: 3,
      lat: 39.963611,
      lng: 121.379167,
    },
    {
      name: '渤海北部一盘锦航路',
      split: [10, 4],
      point: 2,
      distance: 3,
      lat: 40.153889,
      lng: 121.426389,
    },
    {
      name: '渤海北部一盘锦航路',
      split: [10, 4],
      point: 3,
      distance: 3,
      lat: 40.291389,
      lng: 121.644167,
    },
    {
      name: '渤海北部一盘锦航路',
      split: [10, 4],
      point: 4,
      distance: 3,
      lat: 40.336944,
      lng: 121.716389,
    },
    {
      name: '渤海北部一秦皇岛航路',
      split: [13, 5],
      point: 1,
      distance: 6,
      lat: 39.963611,
      lng: 121.379167,
    },
    {
      name: '渤海北部一秦皇岛航路',
      split: [13, 5],
      point: 2,
      distance: 6,
      lat: 39.550556,
      lng: 120.98,
    },
    {
      name: '渤海北部一秦皇岛航路',
      split: [13, 5],
      point: 3,
      distance: 6,
      lat: 39.529444,
      lng: 120.810833,
    },
    {
      name: '渤海北部一秦皇岛航路',
      split: [13, 5],
      point: 4,
      distance: 6,
      lat: 39.599722,
      lng: 120.663333,
    },
    {
      name: '渤海北部一秦皇岛航路',
      split: [13, 5],
      point: 5,
      distance: 6,
      lat: 39.741667,
      lng: 120.0,
    },
    {
      name: '长山水道一天津航路（北侧）',
      split: [13, 5],
      point: 1,
      distance: 2.8,
      lat: 38.133056,
      lng: 120.326389,
    },
    {
      name: '长山水道一天津航路（北侧）',
      split: [13, 5],
      point: 2,
      distance: 2.8,
      lat: 38.357778,
      lng: 119.663333,
    },
    {
      name: '长山水道一天津航路（北侧）',
      split: [13, 5],
      point: 3,
      distance: 2.8,
      lat: 38.483056,
      lng: 119.202222,
    },
    {
      name: '长山水道一天津航路（北侧）',
      split: [13, 5],
      point: 4,
      distance: 2.8,
      lat: 38.556667,
      lng: 118.946389,
    },
    {
      name: '长山水道一天津航路（北侧）',
      split: [13, 5],
      point: 5,
      distance: 2.8,
      lat: 38.643333,
      lng: 118.708056,
    },
    {
      name: '长山水道一天津航路（南侧）',
      split: [4, 10],
      point: 1,
      distance: 2.8,
      lat: 38.088611,
      lng: 120.305556,
    },
    {
      name: '长山水道一天津航路（南侧）',
      split: [4, 10],
      point: 2,
      distance: 2.8,
      lat: 38.2725,
      lng: 119.601111,
    },
    {
      name: '长山水道一天津航路（南侧）',
      split: [4, 10],
      point: 3,
      distance: 2.8,
      lat: 38.436944,
      lng: 119.160833,
    },
    {
      name: '长山水道一天津航路（南侧）',
      split: [4, 10],
      point: 4,
      distance: 2.8,
      lat: 38.610278,
      lng: 118.683889,
    },
    {
      name: '长山水道一黄骅航路（北侧）',
      split: [13, 6],
      point: 1,
      distance: 2.8,
      lat: 38.133056,
      lng: 120.326389,
    },
    {
      name: '长山水道一黄骅航路（北侧）',
      split: [13, 6],
      point: 2,
      distance: 2.8,
      lat: 38.357778,
      lng: 119.663333,
    },
    {
      name: '长山水道一黄骅航路（北侧）',
      split: [13, 6],
      point: 3,
      distance: 2.8,
      lat: 38.483056,
      lng: 119.202222,
    },
    {
      name: '长山水道一黄骅航路（北侧）',
      split: [13, 6],
      point: 4,
      distance: 2.8,
      lat: 38.511111,
      lng: 119.104722,
    },
    {
      name: '长山水道一黄骅航路（北侧）',
      split: [13, 6],
      point: 5,
      distance: 2.8,
      lat: 38.510833,
      lng: 118.758611,
    },
    {
      name: '长山水道一黄骅航路（南侧）',
      split: [13, 6],
      point: 1,
      distance: 4.3,
      lat: 38.088611,
      lng: 120.305556,
    },
    {
      name: '长山水道一黄骅航路（南侧）',
      split: [13, 6],
      point: 2,
      distance: 4.3,
      lat: 38.2725,
      lng: 119.601111,
    },
    {
      name: '长山水道一黄骅航路（南侧）',
      split: [13, 6],
      point: 3,
      distance: 4.3,
      lat: 38.436944,
      lng: 119.160833,
    },
    {
      name: '长山水道一黄骅航路（南侧）',
      split: [13, 6],
      point: 4,
      distance: 4.3,
      lat: 38.511111,
      lng: 118.956944,
    },
    {
      name: '长山水道一黄骅航路（南侧）',
      split: [13, 6],
      point: 5,
      distance: 4.3,
      lat: 38.510833,
      lng: 118.758611,
    },
    {
      name: '老铁山水道一大连旅顺航路',
      split: [13, 6],
      point: 1,
      distance: 1,
      lat: 38.676111,
      lng: 120.911667,
    },
    {
      name: '老铁山水道一大连旅顺航路',
      split: [13, 6],
      point: 2,
      distance: 1,
      lat: 38.790278,
      lng: 121.007778,
    },
    {
      name: '老铁山水道一大连旅顺航路',
      split: [13, 6],
      point: 3,
      distance: 1,
      lat: 38.790278,
      lng: 121.092222,
    },
    {
      name: '老铁山水道一大连旅顺航路',
      split: [13, 6],
      point: 4,
      distance: 1,
      lat: 38.793056,
      lng: 121.111389,
    },
    {
      name: '老铁山水道一大连旅顺航路',
      split: [13, 6],
      point: 5,
      distance: 1,
      lat: 38.795556,
      lng: 121.118056,
    },
    {
      name: '老铁山水道一萌芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头航路',
      split: [9, 19],
      point: 1,
      distance: 6,
      lat: 38.685556,
      lng: 120.823889,
    },
    {
      name: '老铁山水道一萌芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头航路',
      split: [9, 19],
      point: 2,
      distance: 6,
      lat: 38.908333,
      lng: 120.693333,
    },
    {
      name: '老铁山水道一萌芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头航路',
      split: [9, 19],
      point: 3,
      distance: 6,
      lat: 39.3125,
      lng: 120.438889,
    },
    {
      name: '老铁山水道一萌芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头航路',
      split: [9, 19],
      point: 4,
      distance: 6,
      lat: 39.784167,
      lng: 120.273889,
    },
    {
      name: '老铁山水道一萌芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头航路',
      split: [9, 19],
      point: 5,
      distance: 6,
      lat: 39.872778,
      lng: 120.2425,
    },
    {
      name: '老铁山水道一萌芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头航路',
      split: [9, 19],
      point: 6,
      distance: 6,
      lat: 39.963611,
      lng: 120.091667,
    },
    {
      name: '老铁山水道一萌芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头航路',
      split: [9, 19],
      point: 7,
      distance: 6,
      lat: 39.984167,
      lng: 120.067222,
    },
    {
      name: '老铁山水道一萌芦岛绥中石河作业区航路',
      split: [8, 16],
      point: 1,
      distance: 6,
      lat: 38.685556,
      lng: 120.823889,
    },
    {
      name: '老铁山水道一萌芦岛绥中石河作业区航路',
      split: [8, 16],
      point: 2,
      distance: 6,
      lat: 38.908333,
      lng: 120.693333,
    },
    {
      name: '老铁山水道一萌芦岛绥中石河作业区航路',
      split: [8, 16],
      point: 3,
      distance: 6,
      lat: 39.3125,
      lng: 120.438889,
    },
    {
      name: '老铁山水道一萌芦岛绥中石河作业区航路',
      split: [8, 16],
      point: 4,
      distance: 6,
      lat: 39.784167,
      lng: 120.273889,
    },
    {
      name: '老铁山水道一萌芦岛绥中石河作业区航路',
      split: [8, 16],
      point: 5,
      distance: 6,
      lat: 39.872778,
      lng: 120.2425,
    },
    {
      name: '老铁山水道一萌芦岛绥中石河作业区航路',
      split: [8, 16],
      point: 6,
      distance: 6,
      lat: 39.984167,
      lng: 120.161111,
    },
    {
      name: '锦州-锦州2号锚地航路',
      split: [1, 4],
      point: 1,
      distance: 1.6,
      lat: 40.746944,
      lng: 121.084167,
    },
    {
      name: '锦州-锦州2号锚地航路',
      split: [1, 4],
      point: 2,
      distance: 1.6,
      lat: 40.566389,
      lng: 121.447222,
    },
    {
      name: '葫芦岛-锦州2号锚地航路',
      split: [2, 7],
      point: 1,
      distance: 1.6,
      lat: 40.698056,
      lng: 121.033056,
    },
    {
      name: '葫芦岛-锦州2号锚地航路',
      split: [2, 7],
      point: 2,
      distance: 1.6,
      lat: 40.605,
      lng: 121.37,
    },
    {
      name: '葫芦岛-锦州2号锚地航路',
      split: [2, 7],
      point: 3,
      distance: 1.6,
      lat: 40.566389,
      lng: 121.447222,
    },
    {
      name: '锦州-锦州3号锚地航路',
      split: [3, 7],
      point: 1,
      distance: 3,
      lat: 40.724444,
      lng: 121.0525,
    },
    {
      name: '锦州-锦州3号锚地航路',
      split: [3, 7],
      point: 2,
      distance: 3,
      lat: 40.533333,
      lng: 121.083333,
    },
    {
      name: '锦州-锦州3号锚地航路',
      split: [3, 7],
      point: 3,
      distance: 3,
      lat: 40.262222,
      lng: 121.354167,
    },
    {
      name: '营口仙人岛港区航路',
      split: [1, 4],
      point: 1,
      distance: 1.62,
      lat: 40.0675,
      lng: 121.5,
    },
    {
      name: '营口仙人岛港区航路',
      split: [1, 4],
      point: 2,
      distance: 1.62,
      lat: 39.998056,
      lng: 121.387778,
    },
    {
      name: '鲅鱼圈港区钢铁基地作业区(鞍钢码头)推荐航路',
      split: [3, 10],
      point: 1,
      distance: 0.54,
      lat: 40.37,
      lng: 121.807222,
    },
    {
      name: '鲅鱼圈港区钢铁基地作业区(鞍钢码头)推荐航路',
      split: [3, 10],
      point: 2,
      distance: 0.54,
      lat: 40.400556,
      lng: 121.846944,
    },
    {
      name: '鲅鱼圈港区钢铁基地作业区(鞍钢码头)推荐航路',
      split: [3, 10],
      point: 3,
      distance: 0.54,
      lat: 40.404722,
      lng: 121.861944,
    },
    {
      name: '鲅鱼圈港区钢铁基地作业区(鞍钢码头)推荐航路',
      split: [3, 10],
      point: 4,
      distance: 0.54,
      lat: 40.404722,
      lng: 121.943333,
    },
    {
      name: '营口港区推荐航路(第一段)',
      split: [2, 7],
      point: 1,
      distance: 1.08,
      lat: 40.37,
      lng: 121.807222,
    },
    {
      name: '营口港区推荐航路(第一段)',
      split: [2, 7],
      point: 2,
      distance: 1.08,
      lat: 40.400556,
      lng: 121.846944,
    },
    {
      name: '营口港区推荐航路(第一段)',
      split: [2, 7],
      point: 3,
      distance: 1.08,
      lat: 40.4225,
      lng: 121.883889,
    },
    {
      name: '营口港区推荐航路(第二段)',
      split: [1, 4],
      point: 1,
      distance: 1.25,
      lat: 40.457222,
      lng: 121.928889,
    },
    {
      name: '营口港区推荐航路(第二段)',
      split: [1, 4],
      point: 2,
      distance: 1.25,
      lat: 40.481667,
      lng: 121.936111,
    },
    {
      name: '鲅鱼圈港区、营口港区、荣兴港区(盘锦港)-锦州(2号锚地)航路',
      split: [3, 7],
      point: 1,
      distance: 1,
      lat: 40.419167,
      lng: 121.719167,
    },
    {
      name: '鲅鱼圈港区、营口港区、荣兴港区(盘锦港)-锦州(2号锚地)航路',
      split: [3, 7],
      point: 2,
      distance: 1,
      lat: 40.449167,
      lng: 121.6725,
    },
    {
      name: '鲅鱼圈港区、营口港区、荣兴港区(盘锦港)-锦州(2号锚地)航路',
      split: [3, 7],
      point: 3,
      distance: 1,
      lat: 40.543056,
      lng: 121.463333,
    },
    {
      name: '葫芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头一锦州、营口航路',
      split: [8, 16],
      point: 1,
      distance: 3,
      lat: 39.984167,
      lng: 120.067222,
    },
    {
      name: '葫芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头一锦州、营口航路',
      split: [8, 16],
      point: 2,
      distance: 3,
      lat: 39.963611,
      lng: 120.091667,
    },
    {
      name: '葫芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头一锦州、营口航路',
      split: [8, 16],
      point: 3,
      distance: 3,
      lat: 39.872778,
      lng: 120.2425,
    },
    {
      name: '葫芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头一锦州、营口航路',
      split: [8, 16],
      point: 4,
      distance: 3,
      lat: 39.784167,
      lng: 120.273889,
    },
    {
      name: '葫芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头一锦州、营口航路',
      split: [8, 16],
      point: 5,
      distance: 3,
      lat: 39.529444,
      lng: 120.810833,
    },
    {
      name: '葫芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头一锦州、营口航路',
      split: [8, 16],
      point: 6,
      distance: 3,
      lat: 39.550556,
      lng: 120.98,
    },
    {
      name: '葫芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头一天津、秦皇岛航路',
      split: [5, 13],
      point: 1,
      distance: 1,
      lat: 39.984167,
      lng: 120.067222,
    },
    {
      name: '葫芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头一天津、秦皇岛航路',
      split: [5, 13],
      point: 2,
      distance: 1,
      lat: 39.963611,
      lng: 120.091667,
    },
    {
      name: '葫芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头一天津、秦皇岛航路',
      split: [5, 13],
      point: 3,
      distance: 1,
      lat: 39.872778,
      lng: 120.2425,
    },
    {
      name: '葫芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头一天津、秦皇岛航路',
      split: [5, 13],
      point: 4,
      distance: 1,
      lat: 39.784167,
      lng: 120.273889,
    },
    {
      name: '葫芦岛绥中电厂顺达码头、36-1作业区、电厂二期工程配套码头一天津、秦皇岛航路',
      split: [5, 13],
      point: 5,
      distance: 1,
      lat: 39.741667,
      lng: 120.0,
    },
    {
      name: '葫芦岛绥中石河作业区一天津、秦皇岛航路',
      split: [3, 10],
      point: 1,
      distance: 1,
      lat: 39.984167,
      lng: 120.161111,
    },
    {
      name: '葫芦岛绥中石河作业区一天津、秦皇岛航路',
      split: [3, 10],
      point: 2,
      distance: 1,
      lat: 39.872778,
      lng: 120.2425,
    },
    {
      name: '葫芦岛绥中石河作业区一天津、秦皇岛航路',
      split: [3, 10],
      point: 3,
      distance: 1,
      lat: 39.784167,
      lng: 120.273889,
    },
    {
      name: '葫芦岛绥中石河作业区一天津、秦皇岛航路',
      split: [3, 10],
      point: 4,
      distance: 1,
      lat: 39.741667,
      lng: 120.0,
    },
    {
      name: '大连港长兴岛萌芦山湾港区航路(渤海北部方向)',
      split: [1, 4],
      point: 1,
      distance: 1,
      lat: 39.461111,
      lng: 121.227222,
    },
    {
      name: '大连港长兴岛萌芦山湾港区航路(渤海北部方向)',
      split: [1, 4],
      point: 2,
      distance: 1,
      lat: 39.611667,
      lng: 121.038889,
    },
    {
      name: '大连港长兴岛萌芦山湾港区航路(老铁山水道方向)',
      split: [1, 4],
      point: 1,
      distance: 1,
      lat: 39.461111,
      lng: 121.227222,
    },
    {
      name: '大连港长兴岛萌芦山湾港区航路(老铁山水道方向)',
      split: [1, 4],
      point: 2,
      distance: 1,
      lat: 39.346111,
      lng: 120.911111,
    },
    {
      name: '大连港长兴岛北港区航路',
      split: [1, 4],
      point: 1,
      distance: 1.5,
      lat: 39.589444,
      lng: 121.224722,
    },
    {
      name: '大连港长兴岛北港区航路',
      split: [1, 4],
      point: 2,
      distance: 1.5,
      lat: 39.565833,
      lng: 120.994722,
    },
    {
      name: '大连旅顺一天津航路',
      split: [5, 13],
      point: 1,
      distance: 1,
      lat: 38.795556,
      lng: 121.118056,
    },
    {
      name: '大连旅顺一天津航路',
      split: [5, 13],
      point: 2,
      distance: 1,
      lat: 38.793056,
      lng: 121.111389,
    },
    {
      name: '大连旅顺一天津航路',
      split: [5, 13],
      point: 3,
      distance: 1,
      lat: 38.790278,
      lng: 121.092222,
    },
    {
      name: '大连旅顺一天津航路',
      split: [5, 13],
      point: 4,
      distance: 1,
      lat: 38.790278,
      lng: 121.007778,
    },
    {
      name: '大连旅顺一天津航路',
      split: [5, 13],
      point: 5,
      distance: 1,
      lat: 38.630278,
      lng: 120.553056,
    },
    {
      name: '庄河黑岛电厂码头航路',
      split: [2, 7],
      point: 1,
      distance: 0.54,
      lat: 39.570278,
      lng: 123.246667,
    },
    {
      name: '庄河黑岛电厂码头航路',
      split: [2, 7],
      point: 2,
      distance: 0.54,
      lat: 39.390278,
      lng: 123.246667,
    },
    {
      name: '庄河黑岛电厂码头航路',
      split: [2, 7],
      point: 3,
      distance: 0.54,
      lat: 39.2225,
      lng: 123.096111,
    },
    {
      name: '大连港庄河港区航路(丹东方向)',
      split: [10, 4],
      point: 1,
      distance: 1,
      lat: 39.478333,
      lng: 123.096667,
    },
    {
      name: '大连港庄河港区航路(丹东方向)',
      split: [10, 4],
      point: 2,
      distance: 1,
      lat: 39.436667,
      lng: 123.143889,
    },
    {
      name: '大连港庄河港区航路(丹东方向)',
      split: [10, 4],
      point: 3,
      distance: 1,
      lat: 39.381111,
      lng: 123.131667,
    },
    {
      name: '大连港庄河港区航路(丹东方向)',
      split: [10, 4],
      point: 4,
      distance: 1,
      lat: 39.324722,
      lng: 123.362778,
    },
    {
      name: '大连港庄河港区航路(大连方向)',
      split: [2, 7],
      point: 1,
      distance: 1,
      lat: 39.478333,
      lng: 123.096667,
    },
    {
      name: '大连港庄河港区航路(大连方向)',
      split: [2, 7],
      point: 2,
      distance: 1,
      lat: 39.436667,
      lng: 123.143889,
    },
    {
      name: '大连港庄河港区航路(大连方向)',
      split: [2, 7],
      point: 3,
      distance: 1,
      lat: 39.2225,
      lng: 123.096111,
    },
    {
      name: '丹东港一大连航路一',
      split: [6, 16],
      point: 1,
      distance: 3,
      lat: 39.526389,
      lng: 123.786944,
    },
    {
      name: '丹东港一大连航路一',
      split: [6, 16],
      point: 2,
      distance: 3,
      lat: 39.284722,
      lng: 123.280556,
    },
    {
      name: '丹东港一大连航路一',
      split: [6, 16],
      point: 3,
      distance: 3,
      lat: 39.253333,
      lng: 123.2125,
    },
    {
      name: '丹东港一大连航路一',
      split: [6, 16],
      point: 4,
      distance: 3,
      lat: 39.131944,
      lng: 122.753611,
    },
    {
      name: '丹东港一大连航路一',
      split: [6, 16],
      point: 5,
      distance: 3,
      lat: 38.955,
      lng: 122.306111,
    },
    {
      name: '丹东港一大连航路一',
      split: [6, 16],
      point: 6,
      distance: 3,
      lat: 38.783333,
      lng: 121.866667,
    },
    {
      name: '丹东港一大连航路二',
      split: [5, 16],
      point: 1,
      distance: 3,
      lat: 39.343611,
      lng: 123.788889,
    },
    {
      name: '丹东港一大连航路二',
      split: [5, 16],
      point: 2,
      distance: 3,
      lat: 39.1225,
      lng: 123.588056,
    },
    {
      name: '丹东港一大连航路二',
      split: [5, 16],
      point: 3,
      distance: 3,
      lat: 38.933333,
      lng: 123.416667,
    },
    {
      name: '丹东港一大连航路二',
      split: [5, 16],
      point: 4,
      distance: 3,
      lat: 38.6825,
      lng: 122.520833,
    },
    {
      name: '丹东港一大连航路二',
      split: [5, 16],
      point: 5,
      distance: 3,
      lat: 38.583333,
      lng: 122.166667,
    },
    {
      name: '丹东港一大连航路二',
      split: [5, 16],
      point: 6,
      distance: 3,
      lat: 38.75,
      lng: 121.916667,
    },
    {
      name: '涠洲岛东航路',
      split: [3, 7],
      point: 1,
      distance: 3,
      lat: 20.223333,
      lng: 109.7665,
    },
    {
      name: '涠洲岛东航路',
      split: [3, 7],
      point: 2,
      distance: 3,
      lat: 21.1095,
      lng: 109.202167,
    },
    {
      name: '涠洲岛东航路',
      split: [3, 7],
      point: 3,
      distance: 3,
      lat: 21.345167,
      lng: 108.694,
    },
    {
      name: '涠洲岛西航路',
      split: [1, 4],
      point: 1,
      distance: 4,
      lat: 20.151667,
      lng: 109.848833,
    },
    {
      name: '涠洲岛西航路',
      split: [1, 4],
      point: 2,
      distance: 4,
      lat: 21.300333,
      lng: 108.522333,
    },
    {
      name: '北部湾港至东南亚各国航路',
      split: [1, 4],
      point: 1,
      distance: 6,
      lat: 20.116667,
      lng: 108.09,
    },
    {
      name: '北部湾港至东南亚各国航路',
      split: [1, 4],
      point: 2,
      distance: 6,
      lat: 20.993833,
      lng: 108.5545,
    },
    {
      name: '北海港至海南岛西海岸港口航路',
      split: [1, 4],
      point: 1,
      distance: 4,
      lat: 21.052,
      lng: 109.211667,
    },
    {
      name: '北海港至海南岛西海岸港口航路',
      split: [1, 4],
      point: 2,
      distance: 4,
      lat: 20.116667,
      lng: 108.723167,
    },
    {
      name: '琼州海峡西口至越南港口航路',
      split: [1, 4],
      point: 1,
      distance: 4,
      lat: 20.148833,
      lng: 109.8465,
    },
    {
      name: '琼州海峡西口至越南港口航路',
      split: [1, 4],
      point: 2,
      distance: 4,
      lat: 20.401333,
      lng: 108.379167,
    },
    {
      name: '涠洲岛东航路-铁山港支线',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 20.797333,
      lng: 109.401333,
    },
    {
      name: '涠洲岛东航路-铁山港支线',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.181667,
      lng: 109.401333,
    },
    {
      name: '涠洲岛东航路-至石步岭港支线',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.2145,
      lng: 108.975667,
    },
    {
      name: '涠洲岛东航路-至石步岭港支线',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.348333,
      lng: 109.000667,
    },
    {
      name: '涠洲岛东航路-至钦州港东航道支线',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.345167,
      lng: 108.694,
    },
    {
      name: '涠洲岛东航路-至钦州港东航道支线',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.464833,
      lng: 108.636,
    },
    {
      name: '涠洲岛东航路-至钦州港西航道支线',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.345167,
      lng: 108.694,
    },
    {
      name: '涠洲岛东航路-至钦州港西航道支线',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.454,
      lng: 108.556167,
    },
    {
      name: '涠洲岛东航路-至三牙航道支线',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.345167,
      lng: 108.694,
    },
    {
      name: '涠洲岛东航路-至三牙航道支线',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.393167,
      lng: 108.355333,
    },
    {
      name: '北海港至海南岛西海岸港口航路-至铁山港支线',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.052,
      lng: 109.211667,
    },
    {
      name: '北海港至海南岛西海岸港口航路-至铁山港支线',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.181667,
      lng: 109.401333,
    },
    {
      name: '涠洲岛西航路-至企沙东航道支线',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.300333,
      lng: 108.522333,
    },
    {
      name: '涠洲岛西航路-至企沙东航道支线',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.3965,
      lng: 108.489333,
    },
    {
      name: '涠洲岛西航路-至三牙航道支线',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.300333,
      lng: 108.522333,
    },
    {
      name: '涠洲岛西航路-至三牙航道支线',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.393167,
      lng: 108.355333,
    },
    {
      name: '北部湾港至东南亚各国航路-至铁山港支线',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 20.993833,
      lng: 108.5545,
    },
    {
      name: '北部湾港至东南亚各国航路-至铁山港支线',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.181667,
      lng: 109.401333,
    },
    {
      name: '北部湾港至东南亚各国航路-至石步岭港支线',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.082333,
      lng: 108.951,
    },
    {
      name: '北部湾港至东南亚各国航路-至石步岭港支线',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.348333,
      lng: 109.000667,
    },
    {
      name: '北部湾港至东南亚各国航路-至钦州港东航道支线',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 20.993833,
      lng: 108.5545,
    },
    {
      name: '北部湾港至东南亚各国航路-至钦州港东航道支线',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.1555,
      lng: 108.582333,
    },
    {
      name: '北部湾港至东南亚各国航路-至海南洋浦港支线',
      split: [1, 4],
      point: 1,
      distance: 4,
      lat: 20.730833,
      lng: 108.355333,
    },
    {
      name: '北部湾港至东南亚各国航路-至海南洋浦港支线',
      split: [1, 4],
      point: 2,
      distance: 4,
      lat: 20.116667,
      lng: 108.9115,
    },
    {
      name: '北部湾港至东南亚各国航路-至三牙航道支线',
      split: [1, 4],
      point: 1,
      distance: 4,
      lat: 20.618333,
      lng: 108.355333,
    },
    {
      name: '北部湾港至东南亚各国航路-至三牙航道支线',
      split: [1, 4],
      point: 2,
      distance: 4,
      lat: 21.393167,
      lng: 108.355333,
    },
    {
      name: '北海-涠洲航路',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.380333,
      lng: 109.114167,
    },
    {
      name: '北海-涠洲航路',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.088833,
      lng: 109.0805,
    },
    {
      name: '防城港、钦州港至越南海防港及以北航路',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.464833,
      lng: 108.636,
    },
    {
      name: '防城港、钦州港至越南海防港及以北航路',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.130667,
      lng: 108.225333,
    },
    {
      name: '白龙港至越南海防港及以北航路',
      split: [1, 4],
      point: 1,
      distance: 2,
      lat: 21.4855,
      lng: 108.192,
    },
    {
      name: '白龙港至越南海防港及以北航路',
      split: [1, 4],
      point: 2,
      distance: 2,
      lat: 21.328167,
      lng: 108.123,
    },
  ],
  data2: {
    '滨州港~长山水道': [
      [38.361944, 118.386667],
      [38.390556, 118.47],
      [38.381389, 118.688333],
      [38.282778, 119.257222],
      [38.201944, 119.554444],
      [38.098333, 120.267778],
      [38.082222, 120.262222],
      [38.177222, 119.551111],
      [38.263889, 119.238889],
      [38.324722, 118.89],
      [38.356111, 118.478333],
      [38.33, 118.405556],
    ],
    '东营港~长山水道': [
      [38.09, 119.291111],
      [38.056944, 119.542778],
      [38.074722, 120.261389],
      [38.047222, 120.260833],
      [38.020556, 119.5575],
      [38.054722, 119.291111],
    ],
    '广利港、潍坊港~长山水道': [
      [37.6125, 119.610556],
      [37.7625, 119.860278],
      [37.823611, 119.943889],
      [37.898333, 120.029167],
      [38.001111, 120.250556],
      [37.968333, 120.277778],
      [37.845278, 120.052778],
      [37.788333, 119.988611],
      [37.726944, 119.905278],
      [37.576111, 119.655556],
    ],
    莱州港西航路: [
      [37.645833, 119.841667],
      [38.030278, 119.841667],
      [38.031944, 119.8975],
      [37.645833, 119.8975],
    ],
    '龙口港~潍坊港': [
      [37.745556, 120.100556],
      [37.812778, 120.013333],
      [37.757778, 119.9475],
      [37.757778, 120.042222],
      [37.729722, 120.079444],
    ],
    '龙口港~长山水道': [
      [37.749444, 120.146944],
      [37.850278, 120.163889],
      [37.966944, 120.277778],
      [37.934444, 120.328889],
      [37.816667, 120.2125],
      [37.749444, 120.2125],
    ],
    '成山角~老铁山水道': [
      [37.546944, 122.619167],
      [38.3925, 121.175833],
      [38.435833, 121.345556],
      [37.733889, 122.858889],
    ],
    '成山角~长山水道': [
      [37.733889, 122.858889],
      [37.925, 121.431667],
      [37.989722, 121.123056],
      [37.911389, 121.080278],
      [37.546944, 122.619167],
    ],
    '烟台港~老铁山水道': [
      [37.776111, 121.374444],
      [38.3925, 121.108333],
      [38.3925, 121.175833],
      [37.747778, 121.483611],
    ],
    '烟台港~威海港': [
      [37.675, 121.556667],
      [37.693333, 121.995],
      [37.666667, 122.11],
      [37.641667, 121.56],
    ],
    '威海港~成山角': [
      [37.558333, 122.323056],
      [37.558333, 122.568889],
      [37.508889, 122.657778],
      [37.508889, 122.323056],
    ],
    '龙眼港~成山角': [
      [37.458611, 122.624167],
      [37.508333, 122.624167],
      [37.5, 122.665833],
      [37.458611, 122.665833],
    ],
    '荣成湾锚地~成山角': [
      [37.363056, 122.677778],
      [37.363056, 122.765278],
      [37.284167, 122.765278],
      [37.347222, 122.653611],
    ],
    '俚岛~成山角': [
      [37.284167, 122.678611],
      [37.284167, 122.765278],
      [37.270833, 122.765278],
      [37.270833, 122.678611],
    ],
    '成山角南部~青岛港': [
      [36.890556, 122.710556],
      [36.638056, 122.2725],
      [36.323889, 121.632222],
      [36.036111, 120.791667],
      [36.006111, 120.806111],
      [36.283611, 121.657778],
      [36.629167, 122.347222],
      [36.841389, 122.710833],
    ],
    '青岛港~鳌山港': [
      [36.328333, 120.755556],
      [36.2375, 120.885833],
      [36.22, 120.863056],
      [36.3125, 120.733889],
    ],
    '青岛港~日照港（近）': [
      [35.751111, 120.099444],
      [35.394722, 119.898889],
      [35.391389, 119.920556],
      [35.742222, 120.126111],
    ],
    '青岛港~日照港（远）': [
      [35.613611, 120.909444],
      [35.385278, 120.909444],
      [35.385278, 120.953611],
      [35.525556, 120.953611],
    ],
    '青岛港~日韩': [
      [35.966667, 120.825],
      [35.966667, 121.083333],
      [35.913333, 121.083333],
      [35.913333, 120.825],
    ],
    '青岛港~上海、长江口': [
      [35.913333, 120.761111],
      [35.413333, 121.007778],
      [35.431667, 121.066667],
      [35.913333, 120.825],
    ],
    '董家口~成山角': [
      [35.316667, 120.051111],
      [35.316667, 120.5],
      [35.286944, 120.278889],
      [35.286944, 120.100556],
    ],
    '董家口~上海、长江口': [
      [35.311111, 120.039444],
      [35.175, 120.380556],
      [35.155556, 120.325],
      [35.290833, 119.998611],
    ],
    东营港航路: [
      [38.191111, 119.144722],
      [38.258611, 119.257778],
      [38.234444, 119.345556],
      [38.213333, 119.248611],
      [38.167222, 119.170278],
    ],
    '东营港~胜利油田埕岛安全作业区': [
      [38.165833, 119.076944],
      [38.186944, 119.020556],
      [38.15, 118.995278],
      [38.162222, 119.058889],
      [38.1575, 119.071389],
    ],
    '东营港~胜利油田新北安全作业区': [
      [38.074167, 119.124722],
      [37.964722, 119.126944],
      [37.963333, 119.1575],
      [38.073611, 119.154722],
    ],
    '广利港~东营港': [
      [37.498333, 119.405],
      [38.04, 119.405],
      [38.035278, 119.436667],
      [37.516389, 119.436667],
    ],
    广利港航路: [
      [37.413611, 119.105],
      [37.495556, 119.4],
      [37.595556, 119.583333],
      [37.55, 119.583333],
      [37.476389, 119.402778],
      [37.391667, 119.115833],
    ],
    广利渔港航路: [
      [37.364444, 119.005833],
      [37.398333, 119.111389],
      [37.391667, 119.115556],
      [37.357778, 119.01],
    ],
    '东营港~老铁山推荐航线': [
      [38.255, 119.359444],
      [38.361667, 119.583333],
    ],
    '日照港-成山角（青岛港外）航路': [
      [35.236944, 119.829444],
      [35.3125, 120.5],
      [35.278056, 120.5],
      [35.203889, 119.835556],
    ],
    '日照港-青岛港内航路': [
      [35.240833, 119.864167],
      [35.394722, 119.898889],
      [35.391389, 119.920556],
      [35.243333, 119.887222],
    ],
    '日照港-上海、珠江口航路': [
      [35.228889, 120.058611],
      [35.055833, 120.5],
      [35.019167, 120.5],
      [35.220556, 119.985833],
    ],
    '日照港-连云港港（岚山港外）': [
      [35.236944, 119.829444],
      [35.171111, 119.756944],
      [35, 119.755833],
      [35, 119.777778],
      [35.163611, 119.776944],
      [35.203889, 119.835556],
    ],
    '岚山港南作业区-成山角（青岛港外）': [
      [35.044444, 119.708333],
      [35.044444, 120.007778],
      [35.216667, 120.5],
      [35.18, 120.5],
      [35.026389, 120.063056],
      [35.026389, 119.7075],
    ],
    '岚山港中北作业区-成山角（青岛港外）': [
      [35.135, 119.711389],
      [35.115, 119.967222],
      [35.15, 120.309444],
      [35.1025, 120.173611],
      [35.094444, 120.005556],
      [35.116944, 119.710556],
    ],
    '岚山港南作业区-上海、长江口': [
      [35.059722, 120.157778],
      [35.059722, 120.396389],
      [35.026389, 120.481389],
      [35.026389, 120.063056],
    ],
    '岚山港中北作业区-上海、珠江口': [
      [35.098056, 119.957222],
      [35.044444, 119.992222],
      [35.053333, 120.033333],
      [35.094444, 120.005556],
    ],
    '黄海中部大船锚地-日照港': [
      [35.331944, 120.039722],
      [35.26, 119.890833],
      [35.245278, 119.904722],
      [35.316667, 120.051111],
    ],
    '黄海中部大船锚地-岚山港': [
      [35.357222, 120.124167],
      [35.130833, 120.124167],
      [35.085278, 120.124167],
      [35.0775, 120.102222],
      [35.128611, 120.102222],
      [35.350278, 120.102222],
    ],
    龙口港区进港航路: [
      [37.686111, 120.2125],
      [37.816667, 120.2125],
      [37.751389, 120.033333],
      [37.678333, 120.141667],
    ],
    海阳港区进港航路: [
      [36.25, 121.297222],
      [36.468333, 121.286667],
      [36.583333, 121.279167],
      [36.583333, 121.31],
      [36.5, 121.318889],
      [36.403333, 121.345],
      [36.25, 121.353056],
    ],
    长岛港至珍珠门航路: [
      [37.946389, 120.707222],
      [37.965556, 120.696111],
      [37.968333, 120.693889],
      [37.990556, 120.6775],
      [37.990556, 120.676167],
      [37.969444, 120.691111],
      [37.9625, 120.695278],
      [37.947222, 120.699722],
    ],

    '砣矶-旅顺航线南部航路-A': [
      [38.152528, 120.753917],
      [38.144444, 120.751667],
      [38.149556, 120.746222],
      [38.153972, 120.749944],
    ],
    '砣矶-旅顺航线南部航路-B': [
      [38.144444, 120.751667],
      [38.144778, 120.741972],
      [38.163556, 120.685833],
      [38.165778, 120.698222],
      [38.150139, 120.741333],
      [38.149556, 120.746222],
    ],
    '砣矶-旅顺航线南部航路-C': [
      [38.165778, 120.698222],
      [38.175611, 120.690444],
      [38.233333, 120.690444],
      [38.233333, 120.673722],
      [38.163556, 120.685833],
    ],
    蓬旅南端航路: [
      [37.870833, 120.8875],
      [37.922222, 120.969444],
      [38.166667, 120.991667],
      [38.166667, 121.018333],
      [37.870833, 120.99],
    ],
    老铁山水道一东营推荐航线: [
      [38.568889, 120.763333],
      [38.433333, 119.736944],
      [38.316667, 119.547778],
      [38.283333, 119.439167],
      [38.25, 119.37],
    ],
  },
}
